import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  setSelectedCustomer,
  setSelectedProduct,
  setQuantity,
  setPrice,
  setVat,
  setCustomText,
} from "../../../app/store/store";
import jsPDF from "jspdf";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import AsyncSelect from "react-select/async";
import {
  getOutstandingInvoicesByCustomer,
  addInvoice,
} from "../services/invoiceService";
import * as invoiceService from "../services/invoiceService";
import { searchProducts, addProduct } from "../../product/services/productService";
import { getSuppliers } from "../../suppliers/services/supplierService";
import { getProductBrands } from "../../productbrand/services/productBrandService";
import { getCategories } from "../../companysettings/services/productCategoryService";
import { lookupCompanyByVAT, addCustomer } from "../../customers/services/customerService";
import useStoreInfo from '../../../hooks/useCompanyInfo';
import {
  Box,
  Button,
  Checkbox,
  Typography,
  Card,
  CardHeader,
  CardContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Chip,
  Paper,
  Grid,
  Divider,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Container,
  LinearProgress,
  Stack,
  useTheme,
  useMediaQuery,
  alpha,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Switch,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
  FormControlLabel,
} from "@mui/material";
import { toast } from "react-toastify";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import PreviewIcon from "@mui/icons-material/Preview";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import PersonIcon from "@mui/icons-material/Person";
import InventoryIcon from "@mui/icons-material/Inventory";
import PaymentIcon from "@mui/icons-material/Payment";
import DiscountIcon from "@mui/icons-material/Discount";
import NotesIcon from "@mui/icons-material/Notes";
import CalculateIcon from "@mui/icons-material/Calculate";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import QrCodeIcon from "@mui/icons-material/QrCode";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InvoicePreviewDialog from "../../../components/InvoicePreviewDialog";
import useUnsavedChanges from '../../../hooks/useUnsavedChanges';
import UnsavedChangesDialog from '../../../components/UnsavedChangesDialog';
import CustomerSelect from "../components/CustomerSelect";
import ProductSelect from "../components/ProductSelect";
import AddProductDialog from "../../product/components/AddProductDialog";
import OutstandingInvoicesSection from "../../../components/OutstandingInvoicesSection";
import PaymentSection from "../components/PaymentSection";
import MultiplePaymentMethodsSection from "../components/MultiplePaymentMethodsSection";
import { searchCustomers } from "../../customers/services/customerService";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js';
import RefreshIcon from '@mui/icons-material/Refresh';
import SendIcon from '@mui/icons-material/Send';
import CheckCircle from '@mui/icons-material/CheckCircle';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import BusinessIcon from '@mui/icons-material/Business';
import { calculateDueDate } from '../services/invoicePdfService';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { fetchPaymentMethods } from '../../../app/store/slices/paymentMethodSlice';
import { fetchSuppliers, addSupplierToStore } from '../../../app/store/slices/supplierSlice';
import { fetchProductBrands, addBrandToStore } from '../../../app/store/slices/productBrandSlice';
import { fetchProductCategories, addCategoryToStore } from '../../../app/store/slices/productCategorySlice';
import * as documentNoteTemplateService from '../../companysettings/services/documentNoteTemplateService';
import { DocumentType, getDefaultTemplateId, getTemplateContent } from '../../../utils/documentNoteTemplateUtils';

const MAX_CUSTOM_TEXT_LENGTH = 1000;

function stripHtml(html) {
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

function AddInvoicePage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id: invoiceId } = useParams(); // ✅ Get invoice ID from URL for edit mode
  const location = useLocation();
  const isEditMode = Boolean(invoiceId); // ✅ Determine if we're editing
  
  const customers = useSelector((state) => state.customer.customers) || [];
  const products = useSelector((state) => state.product.products) || [];
  const {
    selectedCustomer,
    selectedProduct,
    quantity,
    price,
    vat,
    customText,
  } = useSelector((state) => state.invoice);
  
  // ✅ Get store info from Redux store (auto-fetches if needed)
  const { storeInfo } = useStoreInfo();
  
  // ✅ Move ALL useState declarations to the TOP, before any conditional returns
  const [templateHtml, setTemplateHtml] = useState("");
  const [invoiceProducts, setInvoiceProducts] = useState([]);
  const [editingRowKey, setEditingRowKey] = useState(null);
  const [editFields, setEditFields] = useState({
    Quantity: 1,
    Price: "",
    VAT: 0,
  });

  const [invoicePrice, setInvoicePrice] = useState("");
  const [invoicePaidAmount, setInvoicePaidAmount] = useState("");
  const [invoiceDueAmount, setInvoiceDueAmount] = useState("");

  const [outstandingInvoices, setOutstandingInvoices] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);

  const [invoiceNumber, setInvoiceNumber] = useState("");

  const [invoiceDate, setInvoiceDate] = useState(new Date());

  const [dueDate, setDueDate] = useState(() => {
    const d = new Date();
    d.setDate(d.getDate() + 15);
    return d;
  });

  const [previewHtml, setPreviewHtml] = useState("");
  const [openPreview, setOpenPreview] = useState(false);

  const [discountType, setDiscountType] = useState("percentage");
  const [discountValue, setDiscountValue] = useState(0);

  const [showOutstanding, setShowOutstanding] = useState(false);

  // ✅ Add isSendOnPeppol state HERE, before any conditional returns
  const [isSendOnPeppol, setIsSendOnPeppol] = useState(false);

  // ✅ Add isEmailSend state for email toggle - UI visible but disabled
  const [isEmailSend, setIsEmailSend] = useState(false);

  // ✅ Add loading state for initial data fetch
  const [dataLoading, setDataLoading] = useState(true);

  // ✅ Add invoice-level VAT state (after discountValue state, around line 154)
  const [invoiceVAT, setInvoiceVAT] = useState(21); // Default 21%

  // Add validation state after other useState declarations (around line 154)
  const [paidAmountError, setPaidAmountError] = useState(false);

  // ✅ Add serial number dialog state
  const [serialNumberDialog, setSerialNumberDialog] = useState({ open: false, product: null, serialNumber: "" });

  // ✅ Add payment method state
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentMethodError, setPaymentMethodError] = useState(false);

  // ✅ Add multiple payment methods state
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [useMultiplePayments, setUseMultiplePayments] = useState(false);

  // ✅ Add TVA inclusion toggle state (default ON)
  const [isTvaIncluded, setIsTvaIncluded] = useState(true);

  // ✅ Add attach PDF toggle state (default OFF)
  const [attachPdf, setAttachPdf] = useState(false);

  // ✅ Add confirmation dialog state
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  
  // ✅ Add loading state for invoice creation
  const [creatingInvoice, setCreatingInvoice] = useState(false);

  // ✅ Add dialog states for creating new customer/product
  const [openCustomerDialog, setOpenCustomerDialog] = useState(false);
  const [openProductDialog, setOpenProductDialog] = useState(false);
  const [newCustomerData, setNewCustomerData] = useState({});
  const [customerErrors, setCustomerErrors] = useState({});
  const [vatSearching, setVatSearching] = useState(false);
  
  // ✅ Get payment methods from Redux store
  const paymentMethodOptions = useSelector((state) => state.paymentMethod.paymentMethods) || [];
  
  // ✅ Get suppliers, brands, and categories from Redux store
  const suppliersFromStore = useSelector((state) => state.suppliers.suppliers) || [];
  const brandsFromStore = useSelector((state) => state.productBrands.brands) || [];
  const categoriesFromStore = useSelector((state) => state.productCategories.categories) || [];

  // ✅ Add dialog state for Multiple payment method
  const [showMultipleMethodDialog, setShowMultipleMethodDialog] = useState(false);
  const [creatingMultipleMethod, setCreatingMultipleMethod] = useState(false);

  const { t, i18n } = useTranslation();
  const language =
    useSelector((state) => state.settings?.language) || i18n.language || "nl";

  // Debounce ref
  const debounceRef = useRef();

  // ✅ Fetch payment methods from Redux store
  useEffect(() => {
    if (!paymentMethodOptions || paymentMethodOptions.length === 0) {
      dispatch(fetchPaymentMethods());
    } else {
    }
  }, [dispatch]);

  // ✅ Now all useEffect hooks come after ALL useState declarations
  useEffect(() => {
    // Skip initial data fetch in edit mode - it will be loaded by loadInvoiceForEdit
    if (isEditMode) {
      return;
    }
    
    const fetchInitialData = async () => {
      setDataLoading(true);
      
      try {
        // ✅ Company info is now fetched via Redux hook (useCompanyInfo)
        // No need to fetch manually here

        // ✅ Fetch next invoice number from backend
        try {
          const nextNumber = await invoiceService.getNextInvoiceNumber();
          if (nextNumber && typeof nextNumber === 'string') {
            setInvoiceNumber(nextNumber);
          } else {
            throw new Error('Invalid invoice number format');
          }
        } catch (invoiceNumberError) {
          console.error("❌ Failed to load next invoice number:", invoiceNumberError);
          // Fallback to generated number if API fails
          setInvoiceNumber(generateInvoiceNumber(Date.now() % 10000));
        }

        // ✅ Fetch template with error handling - using template-en.html for all languages
        //const templateFile = "template-en.html";
let templateFile = "template-nl.html";
        if (language === "fr") templateFile = "template-fr.html";
        else if (language === "en") templateFile = "template-en.html";
        try {
          const response = await fetch(`/invoicetemplates/${templateFile}`);
          if (response.ok) {
            const html = await response.text();
            setTemplateHtml(html);
          } else {
            throw new Error(`Failed to load template: ${response.status}`);
          }
        } catch (templateError) {
          console.error('❌ Error fetching template:', templateError);
          setTemplateHtml("");
          toast.warning(t("failed_to_load_template"));
        }
        
      } catch (error) {
        console.error('❌ Critical error during initial data fetch:', error);
        toast.error(t("failed_to_load_initial_data"));
      } finally {
        setDataLoading(false);
      }
    };

    fetchInitialData();
  }, [language, t, dispatch, isEditMode]);

  useEffect(() => {
    const price = parseFloat(invoicePrice) || 0;
    const paid = parseFloat(invoicePaidAmount) || 0;
    setInvoiceDueAmount((price - paid >= 0 ? price - paid : 0).toFixed(2));
  }, [invoicePrice, invoicePaidAmount]);

  // ✅ Sync invoicePaidAmount with multiple payment methods total
  useEffect(() => {
    if (useMultiplePayments && paymentMethods.length > 0) {
      const totalPaid = paymentMethods.reduce((sum, pm) => sum + (parseFloat(pm.amount) || 0), 0);
      setInvoicePaidAmount(totalPaid.toFixed(2));
    }
  }, [useMultiplePayments, paymentMethods]);

  useEffect(() => {
    if (selectedCustomer?.Id) {
      fetchOutstandingInvoices(selectedCustomer.Id);
    } else {
      setOutstandingInvoices([]);
      setSelectedInvoices([]);
    }
  }, [selectedCustomer]);

  // ✅ Add useEffect to reset Peppol toggle when customer changes
  useEffect(() => {
    // Reset Peppol toggle when customer changes
    setIsSendOnPeppol(false);
  }, [selectedCustomer]);

  // ✅ Reset email toggle when customer changes
  useEffect(() => {
    setIsEmailSend(false);
  }, [selectedCustomer]);

  // ✅ Reset attachPdf when Peppol is disabled
  useEffect(() => {
    if (!isSendOnPeppol) {
      setAttachPdf(false);
    }
  }, [isSendOnPeppol]);

  // ✅ Initialize form on mount or load invoice for edit
  useEffect(() => {
    if (isEditMode && invoiceId) {
      loadInvoiceForEdit(invoiceId);
    } else if (!location.state?.fromPos) {
      // Initialize empty form only when NOT coming from POS
      dispatch(setSelectedCustomer(null));
      dispatch(setSelectedProduct(null));
      dispatch(setQuantity(1));
      dispatch(setPrice(""));
      dispatch(setVat(0));
      dispatch(setCustomText(""));
      setOutstandingInvoices([]);
      setSelectedInvoices([]);
      setInvoiceProducts([]);
      setInvoicePaidAmount("0");
      setEditingRowKey(null);
      setEditFields({});
    }
  }, [invoiceId, isEditMode]);

  // Handle data imported from POS ("Convert to Invoice")
  const fromPosImportedRef = React.useRef(false);
  const blocker = useUnsavedChanges(invoiceProducts.length > 0);
  useEffect(() => {
    if (isEditMode || !location.state?.fromPos || fromPosImportedRef.current) return;
    fromPosImportedRef.current = true;

    const { fromPos } = location.state;

    if (fromPos.products?.length > 0) {
      setInvoiceProducts(fromPos.products);
    }
    if (fromPos.customer) {
      dispatch(setSelectedCustomer(fromPos.customer));
    }
    if (fromPos.discount) {
      setDiscountType(fromPos.discount.type === 'percentage' ? 'percentage' : 'fixed');
      setDiscountValue(Number(fromPos.discount.value) || 0);
    }
    if (fromPos.vatRate != null) {
      setInvoiceVAT(Number(fromPos.vatRate));
    }
    if (fromPos.isTvaIncluded != null) {
      setIsTvaIncluded(fromPos.isTvaIncluded);
    }
    if (fromPos.notes) {
      dispatch(setCustomText(fromPos.notes));
    }

    // Clear navigation state so refreshing the page doesn't re-import
    if (window.history.state) {
      window.history.replaceState({ ...window.history.state, usr: null }, '');
    }

    toast.success(t('pos_data_imported') || 'POS data imported to invoice');
  }, [isEditMode, location.state]);

  // Once payment method options load, match the one selected in POS
  useEffect(() => {
    if (isEditMode || !location.state?.fromPos?.paymentMethodId) return;
    if (!paymentMethodOptions.length) return;

    const { paymentMethodId, paymentMethodName } = location.state.fromPos;
    const matched =
      paymentMethodOptions.find(opt => opt.id === paymentMethodId) ||
      paymentMethodOptions.find(
        opt => (opt.name || opt.label || '').toLowerCase() === (paymentMethodName || '').toLowerCase()
      );
    if (matched) {
      setPaymentMethod(matched.value || String(matched.id));
    }
  }, [paymentMethodOptions, isEditMode]);

  // ✅ Handle pre-filled customer from navigation (e.g., from CustomerDetailPage)
  useEffect(() => {
    if (!isEditMode && location.state?.prefilledCustomer) {
      const prefilledCustomer = location.state.prefilledCustomer;
      dispatch(setSelectedCustomer(prefilledCustomer));
      
      // Clear the state to prevent re-population on component updates
      if (window.history.state) {
        window.history.replaceState({ ...window.history.state, usr: null }, '');
      }
    }
  }, [location.state, isEditMode, dispatch]);

  // ✅ Check if "MULTIPLE" payment method exists when toggle is turned on
  useEffect(() => {
    if (useMultiplePayments) {
      const multipleMethodExists = paymentMethodOptions.find(
        opt => opt.value === "MULTIPLE" || opt.label === "MULTIPLE"
      );
      
      if (multipleMethodExists) {
        // Auto-select "MULTIPLE" payment method in the dropdown
        setPaymentMethod(multipleMethodExists.value);
      } else {
        // Show dialog to create MULTIPLE payment method
        setShowMultipleMethodDialog(true);
      }
    }
  }, [useMultiplePayments, paymentMethodOptions]);

  // ✅ Load suppliers, brands, and categories from Redux store (fetch if not present)
  useEffect(() => {
    // Fetch suppliers if not in store
    if (suppliersFromStore.length === 0) {
      dispatch(fetchSuppliers());
    }
    
    // Fetch brands if not in store
    if (brandsFromStore.length === 0) {
      dispatch(fetchProductBrands());
    }
    
    // Fetch categories if not in store
    if (categoriesFromStore.length === 0) {
      dispatch(fetchProductCategories());
    }
  }, [dispatch, suppliersFromStore.length, brandsFromStore.length, categoriesFromStore.length]);

  // ✅ Function to load existing invoice data for editing
  const loadInvoiceForEdit = async (id) => {
    try {
      setDataLoading(true);
      const invoiceData = await invoiceService.getInvoiceById(id);
      
      if (invoiceData) {
        // ✅ Check if invoice is sent via Peppol - prevent editing
        if (invoiceData.IsSendOnPeppol) {
          toast.error('Cannot edit invoices sent via Peppol. This invoice is locked for compliance reasons.');
          navigate('/invoices');
          return;
        }

        // Set invoice number
        setInvoiceNumber(invoiceData.InvoiceNumber || '');
        
        // Set dates
        if (invoiceData.InvoiceDate || invoiceData.CreatedDate) {
          setInvoiceDate(new Date(invoiceData.InvoiceDate || invoiceData.CreatedDate));
        }
        if (invoiceData.DueDate) {
          setDueDate(new Date(invoiceData.DueDate));
        }
        
        // Set payment info
        setInvoicePaidAmount(invoiceData.InvoicePaidAmount?.toString() || '0');
        setPaymentMethod(invoiceData.PaymentMethod || 'CASH');
        
        // ✅ Load SplitPayments if available
        if (invoiceData.SplitPayments && Array.isArray(invoiceData.SplitPayments) && invoiceData.SplitPayments.length > 0) {
          // Map PaymentMethodId back to method name/value
          const mappedPayments = invoiceData.SplitPayments.map((sp, index) => {
            // Find the payment method in options by ID
            const matchedMethod = paymentMethodOptions.find(opt => opt.id === sp.PaymentMethodId);
            return {
              id: Date.now() + index,
              method: matchedMethod?.value || 'CASH',
              amount: sp.Amount?.toString() || '0',
            };
          });
          setPaymentMethods(mappedPayments);
          setUseMultiplePayments(true);
        } else {
          setPaymentMethods([]);
          setUseMultiplePayments(false);
        }
        
        // Set VAT percentage
        setInvoiceVAT(Number(invoiceData.VATPercentage || 21));
        
        // Set discount
        setDiscountType(invoiceData.DiscountType || 'percentage');
        setDiscountValue(invoiceData.DiscountValue || 0);
        
        // Set custom text
        dispatch(setCustomText(invoiceData.CustomText || ''));
        
        // Set Peppol settings
        setIsSendOnPeppol(invoiceData.IsSendOnPeppol || false);
        setAttachPdf(invoiceData.AttachPdf || false);
        
        // Set Email settings
        setIsEmailSend(invoiceData.IsEmailSend || false);
        
        // Set customer
        if (invoiceData.Customer) {
          const customerData = {
            Id: invoiceData.Customer.Id || invoiceData.CustomerId,
            Name: invoiceData.Customer.Name || invoiceData.CustomerName,
            CompanyName: invoiceData.Customer.CompanyName,
            Email: invoiceData.Customer.Email,
            PhoneNumber: invoiceData.Customer.PhoneNumber,
            VATNumber: invoiceData.Customer.VATNumber,
            Street: invoiceData.Customer.Street,
            City: invoiceData.Customer.City,
            PostCode: invoiceData.Customer.PostCode,
            Country: invoiceData.Customer.Country,
            CustomerPeppolId: invoiceData.Customer.CustomerPeppolId,
            // Add label for AsyncSelect display
            label: invoiceData.Customer.CompanyName || invoiceData.Customer.Name || invoiceData.CustomerName,
            value: invoiceData.Customer.Id || invoiceData.CustomerId
          };
          dispatch(setSelectedCustomer(customerData));
        }
        
        // Set line items (products)
        if (invoiceData.LineItems && invoiceData.LineItems.length > 0) {
          const mappedProducts = invoiceData.LineItems.map((item, index) => {
            const totalExcl = Number(item.TotalExcl || 0);
            const vatPercentage = item.VAT || invoiceData.VATPercentage || 21;
            
            // Calculate TotalIncl if not present (using VAT percentage)
            let totalIncl = item.TotalIncl ? Number(item.TotalIncl) : totalExcl * (1 + vatPercentage / 100);
            const vatAmount = item.VATAmount ? Number(item.VATAmount) : totalIncl - totalExcl;
            
            return {
              Id: item.ProductId,
              Name: item.DisplayName || item.ProductName || item.Name || 'Unknown Product',
              Quantity: Number(item.Quantity || 1),
              Price: String(item.UnitPrice || item.Price || 0),
              VAT: vatPercentage,
              TotalExcl: totalExcl.toFixed(2),
              TotalIncl: totalIncl.toFixed(2),
              VATAmount: vatAmount.toFixed(2),
              TotalVAT: vatAmount.toFixed(2),
              TotalInclVAT: totalIncl.toFixed(2),
              SerialNumber: item.SerialNumber || '',
              _rowKey: Date.now() + index
            };
          });
          setInvoiceProducts(mappedProducts);
        }
        
        // ✅ Fetch template HTML for edit mode
        let templateFile = "template-nl.html";
        if (language === "fr") templateFile = "template-fr.html";
        else if (language === "en") templateFile = "template-en.html";
        
        try {
          const response = await fetch(`/invoicetemplates/${templateFile}`);
          if (response.ok) {
            const html = await response.text();
            setTemplateHtml(html);
          } else {
            console.warn(`⚠️ Template not found: ${templateFile}`);
            setTemplateHtml("");
          }
        } catch (templateError) {
          console.error('❌ Error fetching template in edit mode:', templateError);
          setTemplateHtml("");
        }
        
        toast.success(t('invoice_loaded_for_editing'));
      }
    } catch (error) {
      console.error('❌ Error loading invoice for edit:', error);
      toast.error(t('failed_to_load_invoice'));
      navigate('/invoices');
    } finally {
      setDataLoading(false);
    }
  };

  // ✅ Enhanced fetch outstanding invoices with error handling
  const fetchOutstandingInvoices = async (customerId) => {
    try {
      const data = await getOutstandingInvoicesByCustomer(customerId);
      
      // ✅ Service already extracts payload, so data is an array
      if (Array.isArray(data)) {
        setOutstandingInvoices(data);
      } else {
        setOutstandingInvoices([]);
      }
    } catch (error) {
      console.error('❌ Error fetching outstanding invoices:', error);
      setOutstandingInvoices([]);
      
      if (error.response?.status === 404) {
        // No outstanding invoices - not an error
      } else if (error.response?.status === 401) {
        toast.error(t("session_expired"));
      } else if (error.code === 'ERR_NETWORK') {
        toast.error(t("network_error"));
      } else {
        toast.warning(t("failed_to_load_outstanding_invoices"));
      }
    }
  };

  const handleInvoiceToggle = (invoice) => {
    setSelectedInvoices((prev) =>
      prev.some((i) => i.Id === invoice.Id)
        ? prev.filter((i) => i.Id !== invoice.Id)
        : [...prev, invoice]
    );
  };

  const handleAddProduct = () => {
    if (selectedProduct && quantity > 0) {
      // ✅ Calculate net price based on TVA inclusion toggle
      let netPrice = parseFloat(price);
      let totalExclForProduct;
      let vatAmountForProduct = 0;
      let originalTotalWithVAT = 0;
      
      if (isTvaIncluded && invoiceVAT > 0) {
        // If TVA is included, calculate net price and VAT amount exactly
        originalTotalWithVAT = parseFloat(price) * quantity;
        totalExclForProduct = originalTotalWithVAT / (1 + invoiceVAT / 100);
        netPrice = totalExclForProduct / quantity;
        
        // Round net amount
        const roundedTotalExcl = Math.round(totalExclForProduct * 100) / 100;
        
        // Calculate VAT as difference to avoid rounding errors
        vatAmountForProduct = originalTotalWithVAT - roundedTotalExcl;
        totalExclForProduct = roundedTotalExcl;
      } else {
        // Price is already net (TVA not included)
        totalExclForProduct = netPrice * quantity;
        originalTotalWithVAT = 0; // No original total when VAT not included
      }

      // Round values for storage
      const roundedNetPrice = Math.round(netPrice * 100) / 100;
      const roundedTotalExcl = Math.round(totalExclForProduct * 100) / 100;
      const roundedVATAmount = Math.round(vatAmountForProduct * 100) / 100;

      // Check if product with same ID and price already exists
      const existingProductIndex = invoiceProducts.findIndex(
        (p) => p.Id === selectedProduct.Id && parseFloat(p.Price) === roundedNetPrice
      );

      if (existingProductIndex !== -1) {
        // Product exists with same price - increase quantity
        const updatedProducts = [...invoiceProducts];
        const existingProduct = updatedProducts[existingProductIndex];
        const newQuantity = existingProduct.Quantity + quantity;
        
        if (isTvaIncluded && invoiceVAT > 0) {
          // Recalculate for new quantity
          const newOriginalTotal = parseFloat(price) * newQuantity;
          const newTotalExcl = Math.round((newOriginalTotal / (1 + invoiceVAT / 100)) * 100) / 100;
          const newVATAmount = newOriginalTotal - newTotalExcl;
          
          updatedProducts[existingProductIndex] = {
            ...existingProduct,
            Quantity: newQuantity,
            TotalExcl: newTotalExcl.toFixed(2),
            VATAmount: newVATAmount.toFixed(2),
            TotalIncl: newOriginalTotal.toFixed(2),
            TotalVAT: newVATAmount.toFixed(2),
            TotalInclVAT: newOriginalTotal.toFixed(2),
            OriginalTotal: newOriginalTotal.toFixed(2),
          };
        } else {
          const newTotalExcl = Math.round(newQuantity * roundedNetPrice * 100) / 100;
          const newVATAmount = newTotalExcl * (invoiceVAT / 100);
          const newTotalIncl = newTotalExcl + newVATAmount;
          
          updatedProducts[existingProductIndex] = {
            ...existingProduct,
            Quantity: newQuantity,
            TotalExcl: newTotalExcl.toFixed(2),
            VATAmount: newVATAmount.toFixed(2),
            TotalIncl: newTotalIncl.toFixed(2),
            TotalVAT: newVATAmount.toFixed(2),
            TotalInclVAT: newTotalIncl.toFixed(2),
          };
        }
        setInvoiceProducts(updatedProducts);
      } else {
        // Product doesn't exist or has different price - add as new line
        // Calculate VAT and gross total
        let vatAmount, totalIncl;
        if (isTvaIncluded && invoiceVAT > 0) {
          vatAmount = roundedVATAmount;
          totalIncl = originalTotalWithVAT;
        } else {
          vatAmount = roundedTotalExcl * (invoiceVAT / 100);
          totalIncl = roundedTotalExcl + vatAmount;
        }
        
        const newProduct = {
          ...selectedProduct,
          Quantity: quantity,
          Price: roundedNetPrice.toFixed(2),
          TotalExcl: roundedTotalExcl.toFixed(2),
          VATAmount: vatAmount.toFixed(2),
          TotalIncl: totalIncl.toFixed(2),
          TotalVAT: vatAmount.toFixed(2),
          TotalInclVAT: totalIncl.toFixed(2),
          SerialNumber: "",
          _rowKey: Date.now() + Math.random(),
        };
        
        setInvoiceProducts([...invoiceProducts, newProduct]);
      }
      
      dispatch(setSelectedProduct(null));
      dispatch(setQuantity(1));
      dispatch(setPrice(""));
      dispatch(setVat(0)); // Keep this for Redux state cleanup
    }
  };

  const handleRemoveProduct = (rowKey) => {
    setInvoiceProducts(invoiceProducts.filter((p) => p._rowKey !== rowKey));
  };

  // ✅ Add serial number dialog handlers
  const handleOpenSerialNumberDialog = (product) => {
    setSerialNumberDialog({ open: true, product, serialNumber: product.SerialNumber || "" });
  };

  const handleCloseSerialNumberDialog = () => {
    setSerialNumberDialog({ open: false, product: null, serialNumber: "" });
  };

  const handleSaveSerialNumber = () => {
    const { product, serialNumber } = serialNumberDialog;
    if (product) {
      setInvoiceProducts(
        invoiceProducts.map((p) =>
          p._rowKey === product._rowKey
            ? { ...p, SerialNumber: serialNumber }
            : p
        )
      );
    }
    handleCloseSerialNumberDialog();
  };

  // ✅ Add handler for full payment
  const handleFullPayment = () => {
    setInvoicePaidAmount(grandTotal.toFixed(2));
  };

  const handleGeneratePDF = async () => {
    try {
      // ✅ Check if store info is loaded
      if (!storeInfo) {
        toast.warning('Loading store information...');
        await new Promise(resolve => setTimeout(resolve, 1000));
        if (!storeInfo) {
          toast.error('Store information not available. Please refresh the page.');
          return;
        }
      }

      // Use html2pdf for better handling
      const filledHtml = getFilledTemplate();
      const opt = {
        margin: 0,
        filename: `invoice-${invoiceNumber}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { 
          scale: 2, 
          useCORS: true, 
          logging: false,
          width: 794,
          windowWidth: 794,
          letterRendering: true
        },
        jsPDF: { 
          unit: "mm", 
          format: "a4", 
          orientation: "portrait" 
        },
        pagebreak: { 
          mode: ['avoid-all', 'css', 'legacy'],
          before: '.page-break-before',
          after: '.page-break-after',
          avoid: ['tr', 'td', 'img']
        }
      };

      // Generate and save PDF
      await html2pdf().set(opt).from(filledHtml).save();
      
    } catch (error) {
      console.error('❌ PDF generation error:', error);
      
      if (error.message.includes('Invalid canvas')) {
        toast.error(t("failed_to_render_invoice"));
      } else if (error.message.includes('html2canvas')) {
        toast.error(t("failed_to_convert_html"));
      } else {
        toast.error(t("failed_to_generate_pdf"));
      }
    }
  };

  function formatDate(date) {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  }

  // ✅ Calculate totals based on whether products have TVA included
  const totalExcl =
    invoiceProducts.reduce((sum, p) => sum + Number(p.TotalExcl), 0) +
    selectedInvoices.reduce(
      (sum, inv) => sum + Number(inv.InvoiceDueAmount),
      0
    );

  // ✅ Calculate gross total: simply sum the stored TotalIncl values
  const totalGross = invoiceProducts.reduce((sum, p) => {
    return sum + Number(p.TotalIncl);
  }, 0);

  // ✅ Apply discount on gross amount
  let discountAmount = 0;
  if (discountType === "percentage") {
    discountAmount = (totalGross * (parseFloat(discountValue) || 0)) / 100;
  } else {
    discountAmount = parseFloat(discountValue) || 0;
  }

  // ✅ Grand total after discount
  const grandTotal = totalGross - discountAmount;

  // ✅ Extract VAT from the discounted gross amount
  const vatRate = invoiceVAT / 100;
  const totalExclAfterDiscount = grandTotal / (1 + vatRate);
  const totalVAT = grandTotal - totalExclAfterDiscount;

  const totalAmount = grandTotal;

  const customTextSection = stripHtml(customText)
    ? `<div style="margin: 24px 0 16px 0; padding: 12px 16px; background: #fffbe6; border: 1px solid #ffe082; border-radius: 6px;">
      <span style="font-weight: bold; color: #d32f2f; font-size: 1.1em; margin-right: 8px;">${t("notes")}</span>
      <span style="font-weight: 600; color: #795548;">${stripHtml(
        customText
      )}</span>
    </div>`
    : "";

  const getFilledTemplate = () => {
    // ✅ Calculate total quantity
    const totalQuantity = invoiceProducts.reduce((sum, p) => sum + Number(p.Quantity), 0);

    // ✅ Calculate payment status
    const paid = parseFloat(invoicePaidAmount) || 0;
    const total = grandTotal;
    const dueAmount = total - paid;
    let paymentStatus = t("unpaid");
    if (paid >= total) paymentStatus = t("paid");
    else if (paid > 0 && paid < total) paymentStatus = t("partially_paid");
    
    // ✅ Use shared calculateDueDate function for consistency
    const finalDueDate = calculateDueDate(invoiceDate, dueDate, dueAmount);

    // ✅ Only pass payment method if invoice is paid, otherwise default to 'N/A'
    const finalPaymentMethod = paid >= total ? (paymentMethod || "N/A") : "N/A";
    
    // ✅ Build payment methods section for multiple payments
    let paymentMethodsSection = '';
    if (useMultiplePayments && paymentMethods.length > 0 && paid > 0) {
      const paymentMethodsList = paymentMethods
        .map(pm => `<div class="total-row"><span>${pm.method}:</span><strong>€${parseFloat(pm.amount).toFixed(2)}</strong></div>`)
        .join('');
      paymentMethodsSection = paymentMethodsList;
    } else if (paid > 0) {
      paymentMethodsSection = `<div class="total-row"><span>${t("payment_method")}:</span><strong>${finalPaymentMethod}</strong></div>`;
    } else {
      paymentMethodsSection = `<div class="total-row"><span>${t("payment_method")}:</span><strong>N/A</strong></div>`;
    }

    // ✅ Update VAT Section to use invoice-level VAT
    const VATSection = invoiceVAT > 0
      ? `
      <div>
        <span>${invoiceVAT}% ${t("vat")} on €${totalExcl.toFixed(2)}:</span>
        <span>€${totalVAT.toFixed(2)}</span>
      </div>
    `
      : `<div><span>0% ${t("vat")}:</span><span>€0.00</span></div>`;

    // ✅ Build discount row (if applicable)
    const DiscountRow = discountAmount > 0
      ? `
    <tr class="discount-row">
      <td colspan="5" style="text-align:right; font-style: italic;">
        ${discountType === "percentage" ? `${discountValue}%` : `€${discountValue}`} ${t("discount")}:
      </td>
      <td class="text-right">- €${discountAmount.toFixed(2)}</td>
    </tr>
    `
      : '';

    // ✅ Simply use stored values from products - no recalculation needed
    const ProductRows = invoiceProducts.map(p => {
      // ✅ Include serial number in product name if available
      const productName = p.SerialNumber ? `${p.Name} (SN: ${p.SerialNumber})` : p.Name;
      return `
    <tr>
      <td>${productName}</td>
      <td class="text-center">${p.Quantity}</td>
      <td class="text-right">€${parseFloat(p.Price).toFixed(2)}</td>
      <td class="text-right">€${parseFloat(p.TotalExcl).toFixed(2)}</td>
      <td class="text-right">€${parseFloat(p.VATAmount).toFixed(2)}</td>
      <td class="text-right">€${parseFloat(p.TotalIncl).toFixed(2)}</td>
    </tr>
  `;
    }).join('');

    // ✅ Replace all placeholders
    let filledTemplate = templateHtml
      // Company Info
      .replace(/{{CompanyName}}/g, storeInfo?.name || "N/A")
      .replace(/{{CompanyVAT}}/g, storeInfo?.vat || "N/A")
      .replace(/{{CompanyEmail}}/g, storeInfo?.email || "N/A")
      .replace(/{{CompanyIBAN}}/g, storeInfo?.iban || "N/A")
      .replace(/{{CompanyBankDetail}}/g, storeInfo?.iban || "N/A")
      .replace(/{{CompanyStreetAddress}}/g, storeInfo?.address || "")
      .replace(/{{CompanyCityCountry}}/g, [storeInfo?.postCode, storeInfo?.city, storeInfo?.country].filter(Boolean).join(' ') || "")
      .replace(/{{CompanyPhone}}/g, storeInfo?.phone || "")
      
      // Customer Info
      .replace(/{{CustomerName}}/g, selectedCustomer?.CompanyName || selectedCustomer?.Name || "N/A")
      .replace(/{{CustomerId}}/g, selectedCustomer?.Id || "")
      .replace(/{{CustomerVAT}}/g, selectedCustomer?.VATNumber || "N/A")
      .replace(/{{CustomerNumber}}/g, selectedCustomer?.Id || "")
      .replace(/{{CustomerStreetAddress}}/g, `${selectedCustomer?.Street || ""} ${selectedCustomer?.Box || ""}`.trim() || "N/A")
      .replace(/{{CustomerCityCountry}}/g, [selectedCustomer?.PostCode, selectedCustomer?.City, selectedCustomer?.Country].filter(Boolean).join(' ') || "N/A")
      
      // Invoice Info
      .replace(/{{InvoiceNumber}}/g, invoiceNumber)
      .replace(/{{InvoiceDate}}/g, formatDate(invoiceDate))
      .replace(/{{DueDate}}/g, formatDate(finalDueDate))
      .replace(/{{PaymentMethod}}/g, finalPaymentMethod)
      .replace(/{{{PaymentMethodsSection}}}/g, paymentMethodsSection)
      
      // Product Info
      .replace(/{{ProductName}}/g, selectedProduct?.Name || "")
      .replace(/{{ProductId}}/g, selectedProduct?.Id || "")
      .replace(/{{Quantity}}/g, quantity.toString())
      .replace(/{{Price}}/g, price.toString())
      .replace(/{{VAT}}/g, invoiceVAT.toString()) // ✅ Use invoice-level VAT
      
      // Product Rows and Totals
      .replace(/{{{ProductRows}}}/g, ProductRows)
      .replace(/{{TotalQuantity}}/g, totalQuantity.toString())
      .replace(/{{{DiscountRow}}}/g, DiscountRow)
      
      // Financial Totals
      .replace(/{{TotalExcl}}/g, totalExcl.toFixed(2))
      .replace(/{{TotalVAT}}/g, totalVAT.toFixed(2))
      .replace(/{{TotalAmount}}/g, totalAmount.toFixed(2))
      .replace(/{{TotalIncl}}/g, totalIncl.toFixed(2))
      .replace(/{{GrandTotal}}/g, grandTotal.toFixed(2))
      .replace(/{{PaidAmount}}/g, (parseFloat(invoicePaidAmount) || 0).toFixed(2))
      .replace(/{{DueAmount}}/g, (grandTotal - (parseFloat(invoicePaidAmount) || 0)).toFixed(2))
      .replace(/{{InvoicePaidAmount}}/g, (parseFloat(invoicePaidAmount) || 0).toFixed(2))
      .replace(/{{InvoiceDueAmount}}/g, (grandTotal - (parseFloat(invoicePaidAmount) || 0)).toFixed(2))
      
      // VAT Section
      .replace(/{{VATSection}}/g, VATSection)
      
      // Payment Status
      .replace(/{{PaymentStatus}}/g, paymentStatus)
      
      // Outstanding Invoices
      .replace(/{{OutstandingRows}}/g, outstandingRows)
      .replace(/{{OutstandingSection}}/g, outstandingSection)
      
      // Custom Text
      .replace(/{{CustomText}}/g, customText)
      .replace(/{{CustomTextSection}}/g, customTextSection)
      
      // Page Numbers (if applicable)
      .replace(/{{PageNumber}}/g, "1")
      .replace(/{{TotalPages}}/g, "1");

    return filledTemplate;
  };

  const productRows = invoiceProducts
    .map(
      (p) => `
  <tr>
    <td>${p.Name}</td>
    <td>${p.Quantity}</td>
    <td>€${p.Price}</td>
    <td>${p.VAT}%</td>
    <td>€${p.TotalExcl}</td>
  </tr>
`
    )
    .join("");

  const outstandingRows = selectedInvoices
    .map(
      (inv) => `
  <tr>
    <td>${inv.InvoiceNumber}</td>
    <td>${formatDate(inv.CreatedDate)}</td>
    <td>€${inv.InvoiceDueAmount}</td>
  </tr>
`
    )
    .join("");

  const outstandingSection =
    selectedInvoices.length > 0
      ? `
      <h4 style="margin-top:24px;">${t("outstanding_invoices")}</h4>
      <table style="width:100%; border-collapse:collapse; margin-top:12px; font-size:0.85em;">
        <thead>
          <tr style="background:#f6f6f6;">
            <th style="border:1px solid #ccc; padding:8px;">${t("invoice_number")}</th>
            <th style="border:1px solid #ccc; padding:8px;">${t("invoice_date")}</th>
            <th style="border:1px solid #ccc; padding:8px;">${t("total_amount")}</th>
          </tr>
        </thead>
        <tbody>
          ${outstandingRows}
        </tbody>
      </table>
    `
      : "";

  const totalIncl = totalExcl + totalVAT - discountAmount;

  useEffect(() => {
    const paid = parseFloat(invoicePaidAmount) || 0;
    setInvoiceDueAmount((grandTotal - paid >= 0 ? grandTotal - paid : 0).toFixed(2));
  }, [grandTotal, invoicePaidAmount, discountType, discountValue]);

  // ✅ Recalculate subtotal and prices when VAT rate changes (keep grand total same)
  useEffect(() => {
    if (invoiceProducts.length > 0) {
      const updatedProducts = invoiceProducts.map(product => {
        // Keep TotalIncl (gross) the same, recalculate TotalExcl (net) backwards
        const totalIncl = Number(product.TotalIncl);
        const newTotalExcl = totalIncl / (1 + invoiceVAT / 100);
        const newVATAmount = totalIncl - newTotalExcl;
        const newPrice = newTotalExcl / Number(product.Quantity);
        
        return {
          ...product,
          Price: newPrice.toFixed(2),
          VAT: invoiceVAT,
          TotalExcl: newTotalExcl.toFixed(2),
          VATAmount: newVATAmount.toFixed(2)
        };
      });
      setInvoiceProducts(updatedProducts);
    }
  }, [invoiceVAT]);

  const customTextLength = stripHtml(customText).length;

  // ─── Note templates ──────────────────────────────────────────────────
  const [invoiceNoteTemplates, setInvoiceNoteTemplates] = useState([]);
  const [selectedInvoiceNoteTemplate, setSelectedInvoiceNoteTemplate] = useState('');

  useEffect(() => {
    // Skip if templates already loaded
    if (invoiceNoteTemplates.length > 0) return;
    
    documentNoteTemplateService.getTemplatesByType('Invoice')
      .then((data) => {
        const allTemplates = data?.payload || data || [];
        // Filter templates by DocumentType.Invoice (2)
        const templates = allTemplates.filter(t => 
          t.DocumentType === 2 || // DocumentType.Invoice
          t.DocumentType === 99   // DocumentType.All
        );
        setInvoiceNoteTemplates(templates);
        // Auto-select default or first template and populate customText (only if not in edit mode)
        if (templates.length > 0 && !isEditMode && !customText) {
          const defaultTemplate = templates.find(t => t.IsDefault) || templates[0];
          setSelectedInvoiceNoteTemplate(defaultTemplate.Id);
          const plainText = stripHtml(defaultTemplate.NoteContent);
          dispatch(setCustomText(plainText.slice(0, MAX_CUSTOM_TEXT_LENGTH)));
        }
      })
      .catch(() => {});
  }, []);

  const handleInvoiceTemplateSelect = (id) => {
    setSelectedInvoiceNoteTemplate(id);
    if (!id) return;
    const tmpl = invoiceNoteTemplates.find((t) => t.Id === id);
    if (tmpl) dispatch(setCustomText(stripHtml(tmpl.NoteContent).slice(0, MAX_CUSTOM_TEXT_LENGTH)));
  };

  const handleCustomTextChange = (value) => {
    const plainText = stripHtml(value);
    if (plainText.length <= MAX_CUSTOM_TEXT_LENGTH) {
      dispatch(setCustomText(value));
    } else {
      const allowedText = plainText.slice(0, MAX_CUSTOM_TEXT_LENGTH);
      dispatch(setCustomText(allowedText));
    }
  };

  const loadCustomerOptions = async (inputValue) => {
    try {
      const data = await searchCustomers(inputValue);
      
      const customersArray = Array.isArray(data?.payload)
        ? data.payload
        : Array.isArray(data)
        ? data
        : Array.isArray(data?.data)
        ? data.data
        : [];

      return customersArray.map((c) => ({
        ...c,
        value: c.Id,
        label: `${c.CompanyName || c.Name} (${c.Email || 'No email'})`,
      }));
    } catch (error) {
      console.error('❌ Error searching customers:', error);
      
      if (error.response?.status === 401) {
        toast.error(t("session_expired"));
      } else if (error.code === 'ERR_NETWORK') {
        toast.error(t("network_error"));
      }
      
      return [];
    }
  };

  const loadProductOptions = (inputValue, callback) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(async () => {
      if (!inputValue) return callback([]);

      try {
        const barcodeLengths = [8, 12, 13, 14];
        let paramsObj;

        if (barcodeLengths.includes(inputValue.length) && /^\d+$/.test(inputValue)) {
          paramsObj = { skuBarCode: inputValue };
        } else if (/^\d+$/.test(inputValue)) {
          paramsObj = { skuBarCode: inputValue, id: inputValue };
        } else if (inputValue.length >= 3) {
          paramsObj = { name: inputValue };
        } else {
          return callback([]);
        }

        const data = await searchProducts(paramsObj);

        // ✅ Safely handle undefined or missing payload
        const productsArray = Array.isArray(data?.payload)
          ? data.payload
          : Array.isArray(data)
          ? data
          : Array.isArray(data?.data)
          ? data.data
          : [];

        // ✅ Limit results to improve performance - only show first 50 products
        const limitedProducts = productsArray.slice(0, 50);

        callback(
          limitedProducts.map((p) => ({
            value: p.Id,
            label: `${p.Name} (€${p.SalePrice || 0})${p.SKU ? " - SKU: " + p.SKU : ""}${p.BarCode ? " - BarCode: " + p.BarCode : ""}`,
            ...p,
          }))
        );
      } catch (error) {
        console.error('❌ Error searching products:', error);
        
        if (error.response?.status === 401) {
          toast.error(t("session_expired"));
        } else if (error.code === 'ERR_NETWORK') {
          toast.error(t("network_error"));
        }
        
        callback([]);
      }
    }, 350);
  };

  const handleAddInvoiceAndGeneratePDF = async () => {
    // Validate paid amount
    if (!invoicePaidAmount || invoicePaidAmount === "" || parseFloat(invoicePaidAmount) < 0) {
      setPaidAmountError(true);
      return;
    }

    // ✅ Validate that payment methods are loaded from database
    if (!paymentMethodOptions || paymentMethodOptions.length === 0) {
      toast.error(t('payment_methods_not_loaded') || 'Payment methods not loaded. Please refresh the page.');
      return;
    }

    // ✅ Validate payment method selection for single payment
    if (!useMultiplePayments && !paymentMethod) {
      setPaymentMethodError(true);
      toast.error(t('please_select_payment_method') || 'Please select a payment method');
      return;
    }

    // ✅ Validate multiple payments if enabled
    if (useMultiplePayments) {
      // Check if no payment methods added at all
      if (paymentMethods.length === 0) {
        toast.error(t('no_payment_methods_added') || 'Please add payment methods. You need at least 2 payment methods or switch to single payment.');
        return;
      }
      
      // Check if only 1 payment method added
      if (paymentMethods.length === 1) {
        toast.error(t('minimum_two_payment_methods') || 'You selected multiple payment methods but only added one. Please add at least 2 payment methods or use single payment.');
        return;
      }

      // Check for duplicate payment methods
      const methodCounts = {};
      for (const pm of paymentMethods) {
        methodCounts[pm.method] = (methodCounts[pm.method] || 0) + 1;
        if (methodCounts[pm.method] > 1) {
          toast.error(t('duplicate_payment_method') || `You cannot add the same payment method (${pm.method}) multiple times. Please select different payment methods.`);
          return;
        }
      }

      // Validate amounts and method existence
      const hasInvalidPayment = paymentMethods.some(pm => {
        const amount = parseFloat(pm.amount);
        const methodExists = paymentMethodOptions.find(opt => opt.value === pm.method);
        return !methodExists || amount <= 0 || isNaN(amount);
      });

      if (hasInvalidPayment) {
        toast.error(t('invalid_payment_methods') || 'Please ensure all payment methods are valid and amounts are greater than 0');
        return;
      }
    }

    // Reset error if validation passes
    setPaidAmountError(false);
    
    // Show confirmation dialog
    setShowConfirmDialog(true);
  };

  const handleConfirmCreateInvoice = async () => {
    setShowConfirmDialog(false);
    setCreatingInvoice(true);

    try {
      // ✅ Use constant status values that backend expects (not translated)
      let status = "UNPAID";
      const paid = parseFloat(invoicePaidAmount) || 0;
      const total = grandTotal;
      if (paid >= total) status = "PAID";
      else if (paid > 0 && paid < total) status = "PARTIALLY_PAID";

      // ✅ Backend expects PascalCase field names for both JSON and FormData
      // ✅ Determine payment method based on whether multiple payments are used
      let finalPaymentMethod, finalPaymentMethodId;
      
      if (useMultiplePayments) {
        // Find the MULTIPLE payment method from loaded options
        const multipleMethod = paymentMethodOptions.find(
          opt => opt.value === "MULTIPLE" || opt.label === "MULTIPLE" || opt.label?.toLowerCase() === "multiple"
        );
        
        if (!multipleMethod) {
          throw new Error(t('multiple_payment_method_not_found') || 'MULTIPLE payment method not found. Please ensure it exists in payment methods.');
        }
        
        finalPaymentMethod = multipleMethod.value;
        finalPaymentMethodId = multipleMethod.id;
      } else {
        // Use single payment method
        const singleMethod = paymentMethodOptions.find(opt => opt.value === paymentMethod);
        
        if (!singleMethod) {
          throw new Error(t('payment_method_not_found') || `Payment method '${paymentMethod}' not found in loaded options.`);
        }
        
        finalPaymentMethod = singleMethod.value;
        finalPaymentMethodId = singleMethod.id;
      }
      
      const invoiceData = {
        ...(isEditMode && invoiceId ? { Id: parseInt(invoiceId) } : {}),
        InvoiceNumber: invoiceNumber,
        InvoiceTotalAmount: total,
        InvoicePaidAmount: paid,
        InvoiceDueAmount: Math.max(total - paid, 0),
        InvoiceUrl: "test",
        CustomerId: selectedCustomer?.Id || selectedCustomer?.value,
        CustomText: stripHtml(customText),
        Status: status,
        VATPercentage: invoiceVAT,
        IsSendOnPeppol: isSendOnPeppol,
        IsEmailSend: false, // ⛔ Always false - email functionality disabled
        PaymentMethod: finalPaymentMethod,
        PaymentMethodId: finalPaymentMethodId,
        IssueDate: invoiceDate.toISOString(),
        PaymentDueDate: (total - paid) > 0 ? dueDate.toISOString() : null,
        InvoiceSubTotal: parseFloat(totalExclAfterDiscount.toFixed(2)),
        InvoiceTotalVATAmount: parseFloat(totalVAT.toFixed(2)),
        InvoiceDiscount: parseFloat(discountAmount.toFixed(2)),
        // ✅ Add SplitPayments if multiple payment methods are used, otherwise null
        SplitPayments: useMultiplePayments && paymentMethods.length > 0 ? paymentMethods.map(pm => {
          // Find the payment method ID from the options
          const selectedMethod = paymentMethodOptions.find(opt => opt.value === pm.method);
          
          if (!selectedMethod || !selectedMethod.id) {
            throw new Error(t('payment_method_not_found') || `Payment method '${pm.method}' not found or has no ID.`);
          }
          
          const amount = parseFloat(pm.amount);
          if (isNaN(amount) || amount <= 0) {
            throw new Error(t('invalid_payment_amount') || `Invalid amount for payment method '${pm.method}'.`);
          }
          
          return {
            PaymentMethodId: selectedMethod.id,
            Amount: amount
          };
        }) : null,
        LineItems: invoiceProducts.map((p) => ({
          ProductId: p.Id,
          Quantity: p.Quantity,
          Price: p.Price,
          TotalExcl: p.TotalExcl,
          VatAmount: p.VATAmount,
          TotalIncl: p.TotalIncl,
          TotalVAT: p.TotalVAT || p.VATAmount,
          TotalInclVAT: p.TotalInclVAT || p.TotalIncl,
          SerialNumber: p.SerialNumber || "",
          UpdatedProductName: p.SerialNumber ? `${p.Name} (${p.SerialNumber})` : p.Name,
        })),
        OutstandingInvoices: selectedInvoices.map((inv) => ({
          InvoiceId: inv.Id,
          InvoiceNumber: inv.InvoiceNumber,
          DueAmount: inv.InvoiceDueAmount,
        })),
      };

      // ✅ Log payment method data for debugging
      
      if (invoiceData.SplitPayments) {
      } else {
      }

      let response;
      let requestData;
      let isFormData = true; // Always true because backend expects [FromForm]
      
      // ✅ Always create FormData since backend expects [FromForm]
      const formData = new FormData();
      
      // If attachPdf is enabled, generate and attach PDF file first
      if (attachPdf) {
        try {
          
          // Generate PDF blob from the filled template
          const filledHtml = getFilledTemplate();
          const opt = {
            margin: 0,
            filename: `${invoiceNumber}.pdf`,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { 
              scale: 2, 
              useCORS: true, 
              logging: false,
              width: 794,
              windowWidth: 794,
              letterRendering: true
            },
            jsPDF: { 
              unit: "mm", 
              format: "a4", 
              orientation: "portrait" 
            },
            pagebreak: { 
              mode: ['avoid-all', 'css', 'legacy'],
              before: '.page-break-before',
              after: '.page-break-after',
              avoid: ['tr', 'td', 'img']
            }
          };
          
          // Generate PDF blob - correct method
          const pdf = html2pdf().set(opt).from(filledHtml);
          const pdfBlob = await pdf.output('blob');
          
          
          // Attach PDF file to FormData
          formData.append('Attachments', pdfBlob, `${invoiceNumber}.pdf`);
          
        } catch (pdfError) {
          console.error('❌ Error generating PDF:', pdfError);
          toast.error(t("pdf_generation_failed") + ": " + pdfError.message);
          setCreatingInvoice(false);
          return; // Exit if PDF generation fails
        }
      }
      
      // ✅ Add all invoice data to FormData (always, regardless of PDF attachment)
      // ✅ Add Id for edit mode
      if (isEditMode && invoiceId) {
        formData.append('Id', invoiceId.toString());
      }
      formData.append('InvoiceNumber', invoiceData.InvoiceNumber);
      formData.append('InvoiceTotalAmount', invoiceData.InvoiceTotalAmount.toString());
      formData.append('InvoicePaidAmount', invoiceData.InvoicePaidAmount.toString());
      formData.append('InvoiceDueAmount', invoiceData.InvoiceDueAmount.toString());
      formData.append('InvoiceUrl', invoiceData.InvoiceUrl);
      formData.append('CustomerId', invoiceData.CustomerId.toString());
      formData.append('CustomText', invoiceData.CustomText);
      formData.append('Status', invoiceData.Status);
      formData.append('VATPercentage', invoiceData.VATPercentage.toString());
      formData.append('IsSendOnPeppol', invoiceData.IsSendOnPeppol.toString());
      formData.append('IsEmailSend', invoiceData.IsEmailSend.toString());
      formData.append('PaymentMethod', invoiceData.PaymentMethod);
      // ✅ Always send PaymentMethodId if available (nullable int in backend)
      if (invoiceData.PaymentMethodId !== null && invoiceData.PaymentMethodId !== undefined) {
        formData.append('PaymentMethodId', invoiceData.PaymentMethodId.toString());
      }
      formData.append('IssueDate', invoiceData.IssueDate);
      if (invoiceData.PaymentDueDate) {
        formData.append('PaymentDueDate', invoiceData.PaymentDueDate);
      }
      formData.append('InvoiceSubTotal', invoiceData.InvoiceSubTotal.toString());
      formData.append('InvoiceTotalVATAmount', invoiceData.InvoiceTotalVATAmount.toString());
      formData.append('InvoiceDiscount', invoiceData.InvoiceDiscount.toString());
      
      // ✅ Append SplitPayments if multiple payment methods are used
      if (invoiceData.SplitPayments && invoiceData.SplitPayments.length > 0) {
        invoiceData.SplitPayments.forEach((sp, index) => {
          formData.append(`SplitPayments[${index}].PaymentMethodId`, sp.PaymentMethodId.toString());
          formData.append(`SplitPayments[${index}].Amount`, sp.Amount.toString());
        });
      }
      
      // ✅ Append LineItems as individual indexed fields for FormData binding
      invoiceData.LineItems.forEach((item, index) => {
        formData.append(`LineItems[${index}].ProductId`, item.ProductId.toString());
        formData.append(`LineItems[${index}].Quantity`, item.Quantity.toString());
        formData.append(`LineItems[${index}].Price`, item.Price.toString());
        formData.append(`LineItems[${index}].TotalExcl`, item.TotalExcl.toString());
        formData.append(`LineItems[${index}].VatAmount`, item.VatAmount.toString());
        formData.append(`LineItems[${index}].TotalIncl`, item.TotalIncl.toString());
        formData.append(`LineItems[${index}].TotalVAT`, item.TotalVAT.toString());
        formData.append(`LineItems[${index}].TotalInclVAT`, item.TotalInclVAT.toString());
        formData.append(`LineItems[${index}].SerialNumber`, item.SerialNumber || '');
        formData.append(`LineItems[${index}].UpdatedProductName`, item.UpdatedProductName || '');
      });
      
      // ✅ Append OutstandingInvoices as individual indexed fields for FormData binding
      invoiceData.OutstandingInvoices.forEach((inv, index) => {
        formData.append(`OutstandingInvoices[${index}].InvoiceId`, inv.InvoiceId.toString());
        formData.append(`OutstandingInvoices[${index}].InvoiceNumber`, inv.InvoiceNumber);
        formData.append(`OutstandingInvoices[${index}].DueAmount`, inv.DueAmount.toString());
      });
      
      requestData = formData;

      // Send request
      if (isEditMode && invoiceId) {
        // Update existing invoice
        response = await invoiceService.updateInvoice(invoiceId, requestData, isFormData);
      } else {
        // Create new invoice
        response = await addInvoice(requestData, isFormData);
      }

      if (response) {
        toast.success(isEditMode ? t("invoice_updated_success") : t("invoice_created_success"));
        await handleGeneratePDF();
        
        if (!isEditMode) {
          resetInvoiceForm();
        }
        setPaidAmountError(false);
        
        // ✅ Redirect to list invoices page after successful creation/update
        setTimeout(() => {
          navigate('/invoices');
        }, 1500); // 1.5 second delay to show success message and allow PDF download
      } else {
        throw new Error('Invalid response from server');
      }
    } catch (error) {
      console.error(isEditMode ? '❌ Error updating invoice:' : '❌ Error creating invoice:', error);
      
      if (error.response?.status === 400) {
        toast.error(t("invalid_invoice_data"));
      } else if (error.response?.status === 401) {
        toast.error(t("session_expired"));
      } else if (error.response?.status === 409) {
        toast.error(isEditMode ? t("invoice_update_conflict") : t("invoice_already_exists"));
      } else if (error.code === 'ERR_NETWORK') {
        toast.error(t("network_error"));
      } else {
        toast.error(error.response?.data?.message || (isEditMode ? t("invoice_updated_error") : t("invoice_created_error")));
      }
    } finally {
      setCreatingInvoice(false);
    }
  };

  // ✅ Handlers for Add Customer Dialog
  //const [customerErrors, setCustomerErrors] = useState({});
  //const [vatSearching, setVatSearching] = useState(false);

  const handleOpenCustomerDialog = () => {
    setNewCustomerData({
      vat: '',
      companyName: '',
      customerName: '',
      email: '',
      phoneNumber: '',
      street: '',
      box: '',
      postCode: '',
      city: '',
      country: 'Belgium',
      peppolId: '',
      isActive: 'true'
    });
    setCustomerErrors({});
    setOpenCustomerDialog(true);
  };

  const handleCloseCustomerDialog = () => {
    setOpenCustomerDialog(false);
    setNewCustomerData({});
    setCustomerErrors({});
  };

  const handleVATLookup = async () => {
    if (!newCustomerData.vat || newCustomerData.vat.trim() === '') {
      toast.error(t("please_enter_vat_number") || "Please enter a VAT number");
      setCustomerErrors({ ...customerErrors, vat: t("please_enter_vat_number") });
      return;
    }

    // Remove 'BE' prefix if present
    const cleanVAT = newCustomerData.vat.replace(/^BE/i, '').trim();
    
    if (!/^\d+$/.test(cleanVAT)) {
      setCustomerErrors({ ...customerErrors, vat: t("invalid_vat_format") || "Invalid VAT format. Only numbers are allowed" });
      toast.error(t("invalid_vat_format") || "Invalid VAT format. Only numbers are allowed");
      return;
    }

    try {
      setVatSearching(true);
      const response = await lookupCompanyByVAT(cleanVAT);
      const data = response?.payload || response?.data?.payload || response;
      
      if (data && data.Found) {
        // Auto-fill company data from VAT lookup
        setNewCustomerData({
          ...newCustomerData,
          vat: data.EnterpriseNumber || newCustomerData.vat,
          companyName: data.CompanyName || '',
          customerName: data.CompanyName || '', // Also fill customer name
          street: data.StreetAddress || '',
          box: data.Box || '',
          postCode: data.PostCode || '',
          city: data.City || '',
          country: (data.FullAddress && data.FullAddress.includes('BE')) ? 'Belgium' : 'Belgium',
          isActive: data.Status && data.Status.toLowerCase() === 'active' ? 'true' : 'false'
        });
        toast.success(t("company_data_loaded") || "Company data loaded successfully. Please fill remaining fields.");
      } else {
        toast.warning(t("company_not_found") || "No company found with this VAT number");
      }
    } catch (error) {
      console.error('VAT lookup error:', error);
      toast.error(t("vat_lookup_failed") || "Failed to lookup VAT number. Please try again.");
    } finally {
      setVatSearching(false);
    }
  };

  const handleCreateCustomer = async () => {
    try {
      // Validation
      const errors = {};
      if (!newCustomerData.vat || newCustomerData.vat.trim() === '') {
        errors.vat = t("vat_required") || "VAT Number is required";
      }
      if (!newCustomerData.companyName || newCustomerData.companyName.trim() === '') {
        errors.companyName = t("company_name_required") || "Company Name is required";
      }
      if (!newCustomerData.customerName || newCustomerData.customerName.trim() === '') {
        errors.customerName = t("customer_name_required") || "Customer Name is required";
      }
      if (!newCustomerData.email || newCustomerData.email.trim() === '') {
        errors.email = t("email_required") || "Email is required";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newCustomerData.email)) {
        errors.email = t("invalid_email") || "Invalid email format";
      }
      if (!newCustomerData.phoneNumber || newCustomerData.phoneNumber.trim() === '') {
        errors.phoneNumber = t("phone_required") || "Phone Number is required";
      }
      if (!newCustomerData.street || newCustomerData.street.trim() === '') {
        errors.street = t("street_required") || "Street is required";
      }
      if (!newCustomerData.postCode || newCustomerData.postCode.trim() === '') {
        errors.postCode = t("postal_code_required") || "Postal Code is required";
      }
      if (!newCustomerData.city || newCustomerData.city.trim() === '') {
        errors.city = t("city_required") || "City is required";
      }

      if (Object.keys(errors).length > 0) {
        setCustomerErrors(errors);
        return;
      }

      const customerPayload = {
        VATNumber: newCustomerData.vat,
        CompanyName: newCustomerData.companyName,
        Name: newCustomerData.customerName,
        Email: newCustomerData.email,
        PhoneNumber: newCustomerData.phoneNumber,
        Street: newCustomerData.street,
        Box: newCustomerData.box || '',
        PostCode: newCustomerData.postCode,
        City: newCustomerData.city,
        Country: newCustomerData.country || 'Belgium',
        CustomerPeppolId: newCustomerData.peppolId || '',
        Status: newCustomerData.isActive === 'true',
        CreatedDate: new Date().toISOString(),
        IsDeleted: false
      };

      // ✅ Call API once and get the created customer response
      const response = await addCustomer(customerPayload);
      const createdCustomer = response?.payload || response?.data || response;
      
      if (createdCustomer) {
        // Format customer for selection
        const customerForSelection = {
          value: createdCustomer.Id,
          label: createdCustomer.CompanyName || createdCustomer.Name,
          Id: createdCustomer.Id,
          Name: createdCustomer.Name,
          CompanyName: createdCustomer.CompanyName,
          Email: createdCustomer.Email,
          PhoneNumber: createdCustomer.PhoneNumber,
          VATNumber: createdCustomer.VATNumber,
          Street: createdCustomer.Street,
          Box: createdCustomer.Box,
          PostCode: createdCustomer.PostCode,
          City: createdCustomer.City,
          Country: createdCustomer.Country,
          CustomerPeppolId: createdCustomer.CustomerPeppolId,
        };
        
        // Select the newly created customer
        dispatch(setSelectedCustomer(customerForSelection));
        toast.success(t("customer_created_and_selected") || "Customer created and selected!");
      } else {
        toast.success(t("customer_created_successfully"));
      }
      
      handleCloseCustomerDialog();
    } catch (error) {
      console.error('Error creating customer:', error);
      toast.error(error.response?.data?.message || t("error_creating_customer"));
    }
  };

  // ✅ Handlers for Add Product Dialog
  const handleOpenProductDialog = () => {
    setOpenProductDialog(true);
  };

  const handleCloseProductDialog = () => {
    setOpenProductDialog(false);
  };

  const handleCreateProduct = async () => {
    try {
      // Validation
      const errors = {};
      if (!newProductData.name || newProductData.name.trim() === '') {
        errors.name = t("product_name_required") || "Product Name is required";
      }
      if (!newProductData.categoryId) {
        errors.categoryId = t("category_required") || "Category is required";
      }
      if (!newProductData.supplierId) {
        errors.supplierId = t("supplier_required") || "Supplier is required";
      }
      if (!newProductData.price || parseFloat(newProductData.price) <= 0) {
        errors.price = t("valid_price_required") || "Valid price is required";
      }
      if (!newProductData.costPrice || parseFloat(newProductData.costPrice) < 0) {
        errors.costPrice = t("valid_cost_price_required") || "Valid cost price is required";
      }
      if (!newProductData.stockQuantity || parseInt(newProductData.stockQuantity) < 0) {
        errors.stockQuantity = t("valid_stock_quantity_required") || "Valid stock quantity is required";
      }

      if (Object.keys(errors).length > 0) {
        setProductErrors(errors);
        return;
      }

      const productPayload = {
        Name: newProductData.name,
        ProductName: newProductData.name,
        Description: newProductData.description || '',
        SKU: newProductData.sku && newProductData.sku.trim() ? newProductData.sku.trim() : null,
        Barcode: newProductData.barcode && newProductData.barcode.trim() ? newProductData.barcode.trim() : null,
        ProductCategoryId: newProductData.categoryId ? parseInt(newProductData.categoryId) : null,
        SalePrice: parseFloat(newProductData.price),
        CostPrice: parseFloat(newProductData.costPrice) || 0,
        StockQuantity: parseInt(newProductData.stockQuantity) || 0,
        MinStockLevel: parseInt(newProductData.minStockLevel) || 0,
        SupplierId: newProductData.supplierId ? parseInt(newProductData.supplierId) : null,
        ProductBrandId: newProductData.productBrandId ? parseInt(newProductData.productBrandId) : null,
        IsActive: newProductData.isActive
      };

      // ✅ Call API once and get the created product response
      const response = await addProduct(productPayload);
      const createdProduct = response?.payload || response?.data || response;
      
      if (createdProduct) {
        // Format product for selection
        const productForSelection = {
          value: createdProduct.Id,
          label: `${createdProduct.Name} (€${createdProduct.SalePrice || 0})`,
          Id: createdProduct.Id,
          Name: createdProduct.Name,
          SKU: createdProduct.SKU,
          BarCode: createdProduct.Barcode,
          SalePrice: createdProduct.SalePrice,
          CostPrice: createdProduct.CostPrice,
          StockQuantity: createdProduct.StockQuantity,
          Description: createdProduct.Description,
          ProductCategoryId: createdProduct.ProductCategoryId,
          SupplierId: createdProduct.SupplierId,
          ProductBrandId: createdProduct.ProductBrandId,
        };
        
        // Select the newly created product but DON'T add it to invoice
        dispatch(setSelectedProduct(productForSelection));
        dispatch(setPrice(createdProduct.SalePrice || ""));
        toast.success(t("product_created_and_selected") || "Product created and selected! You can now add it to the invoice.");
      } else {
        toast.success(t("product_created_successfully"));
      }
      
      handleCloseProductDialog();
    } catch (error) {
      console.error('Error creating product:', error);
      toast.error(error.response?.data?.message || t("error_creating_product"));
    }
  };

  // ✅ Handler for creating Multiple payment method
  const handleCreateMultiplePaymentMethod = async () => {
    setCreatingMultipleMethod(true);
    try {
      const response = await paymentMethodService.createPaymentMethod({ Name: "MULTIPLE" });
      const createdMethod = response?.payload || response;
      
      if (createdMethod && createdMethod.Id) {
        // Add to payment method options
        const newMethod = {
          id: createdMethod.Id,
          value: "MULTIPLE",
          label: "MULTIPLE"
        };
        setPaymentMethodOptions(prev => [...prev, newMethod]);
        
        toast.success(t('payment_method_created') || 'Multiple payment method created successfully');
        setShowMultipleMethodDialog(false);
      } else {
        throw new Error('Invalid response from server');
      }
    } catch (error) {
      console.error('Error creating Multiple payment method:', error);
      toast.error(t('payment_method_create_failed') || 'Failed to create Multiple payment method');
      // Turn off the toggle since we couldn't create the method
      setUseMultiplePayments(false);
    } finally {
      setCreatingMultipleMethod(false);
    }
  };

  // ✅ Handler for canceling Multiple payment method creation
  const handleCancelMultipleMethod = () => {
    setShowMultipleMethodDialog(false);
    setUseMultiplePayments(false); // Turn off the toggle
  };

  // Add a function to reset the form (if not already exists)
  const resetInvoiceForm = async () => {
    dispatch(setSelectedCustomer(null));
    dispatch(setSelectedProduct(null));
    dispatch(setQuantity(1));
    dispatch(setPrice(""));
    dispatch(setVat(0));
    dispatch(setCustomText(""));
    setInvoiceProducts([]);
    setSelectedInvoices([]);
    setInvoicePaidAmount("");
    setDiscountValue(0);
    setInvoiceVAT(21);
    setIsSendOnPeppol(false);
    setPaidAmountError(false); // Reset error
    setPaymentMethod("CASH"); // ✅ Reset payment method
    setPaymentMethods([]); // ✅ Reset multiple payment methods
    setUseMultiplePayments(false); // ✅ Reset multiple payments toggle
    setInvoiceDate(new Date()); // ✅ Reset invoice date
    setIsTvaIncluded(true); // ✅ Reset TVA inclusion toggle to default ON
    setAttachPdf(false); // ✅ Reset attach PDF toggle to default OFF
    
    // ✅ Fetch next invoice number from API
    try {
      const response = await invoiceService.getNextInvoiceNumber();
      // Extract invoiceNumber from response object
      const nextNumber = response?.invoiceNumber || response?.payload?.invoiceNumber || response?.data?.invoiceNumber || response?.payload || response?.data || response;
      if (nextNumber && typeof nextNumber === 'string') {
        setInvoiceNumber(nextNumber);
      } else {
        throw new Error('Invalid invoice number format');
      }
    } catch (error) {
      console.error("❌ Failed to load next invoice number:", error);
      setInvoiceNumber(generateInvoiceNumber(Date.now() % 10000));
    }
  };

  // ✅ Show warning if template failed to load (only after initial loading is complete)
  if (!templateHtml && !dataLoading) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Paper 
          elevation={3}
          sx={{ 
            p: 4,
            borderRadius: 2,
            bgcolor: alpha(theme.palette.error.main, 0.08),
            border: `1px solid ${alpha(theme.palette.error.main, 0.2)}`
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <ReceiptLongIcon sx={{ fontSize: 60, color: 'error.main' }} />
            <Typography variant="h6" color="error" textAlign="center">
              {t("failed_to_load_template")}
            </Typography>
            <Typography variant="body2" color="text.secondary" textAlign="center">
              {t("please_refresh_or_contact_support")}
            </Typography>
            <Button
              variant="contained"
              onClick={() => window.location.reload()}
              startIcon={<RefreshIcon />}
            >
              {t("refresh_page")}
            </Button>
          </Box>
        </Paper>
      </Container>
    );
  }

  return (
    <Box sx={{
      background: theme.palette.mode === 'dark'
        ? 'linear-gradient(to bottom, #1a1a2e 0%, #16213e 100%)'
        : 'linear-gradient(to bottom, #f8fafc 0%, #f1f5f9 100%)',
      minHeight: '100vh',
      pt: 3,
      pb: 8
    }}>
      <Container 
        maxWidth={false} 
        sx={{ 
          px: { xs: 2, sm: 3, md: 4, lg: 6, xl: 8 },
          maxWidth: { xs: '100%', sm: '100%', md: '100%', lg: '1400px', xl: '1600px' }
        }}
      >
        <Card
          elevation={3}
          sx={{
            borderRadius: '16px',
            overflow: 'hidden',
            mb: 4
          }}
        >
          <CardHeader
            title={
              <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                <Box sx={{
                  bgcolor: alpha(theme.palette.primary.main, 0.15),
                  p: 1.2,
                  borderRadius: '12px',
                  mr: 2
                }}>
                  <ReceiptLongIcon color="primary" fontSize="large" />
                </Box>
                <Typography variant="h5" fontWeight="bold" color="primary">
                  {isEditMode ? t("edit_invoice") : t("invoice_details")}
                </Typography>
                <Chip
                  label={invoiceNumber}
                  color="primary"
                  variant="outlined"
                  size="medium"
                  sx={{
                    fontSize: "1rem",
                    fontWeight: "bold",
                    height: 32,
                    px: 2,
                    borderRadius: '8px',
                    background: alpha(theme.palette.primary.main, 0.08),
                    ml: 2
                  }}
                />
                {isEditMode && invoiceId && (
                  <Button
                    variant="outlined"
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate(`/invoices/view/${invoiceId}`)}
                    sx={{
                      ml: 'auto',
                      borderRadius: '8px',
                      textTransform: 'none',
                      fontWeight: 600,
                    }}
                  >
                    {t("back_to_view") || "Back to View"}
                  </Button>
                )}
              </Box>
            }
            sx={{
              background: alpha(theme.palette.primary.light, 0.1),
              borderBottom: `1px solid ${alpha(theme.palette.divider, 0.5)}`
            }}
          />

          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} md={8}>
                <Stack spacing={3}>
                  {/* Customer Section */}
                  <Paper
                    elevation={1}
                    sx={{
                      p: 2,
                      borderRadius: '12px',
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`
                    }}
                  >
                    <Stack direction="row" alignItems="center" spacing={2} mb={1} justifyContent="space-between">
                      <Box sx={{
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                        <Box sx={{
                          bgcolor: alpha(theme.palette.primary.main, 0.15),
                          p: 1,
                          borderRadius: '10px'
                        }}>
                          <PersonIcon color="primary" />
                        </Box>
                        <Typography variant="subtitle1" fontWeight="bold" color="primary" sx={{ ml: 2 }}>
                          {t("customer")}
                        </Typography>
                      </Box>
                      {/* Right aligned toggle for outstanding invoices and Add Customer button */}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Switch
                          checked={showOutstanding}
                          onChange={() => setShowOutstanding((prev) => !prev)}
                          color="primary"
                          disabled // ✅ Disable toggle
                        />
                        <Typography variant="body2" sx={{ mr: 1, color: 'text.disabled' }}>
                          {t("show_outstanding_invoices")}
                        </Typography>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          startIcon={<AddIcon />}
                          onClick={handleOpenCustomerDialog}
                          sx={{
                            borderRadius: '8px',
                            px: 1.5,
                            py: 0.5,
                            fontWeight: 600,
                            whiteSpace: 'nowrap',
                            fontSize: '0.813rem',
                          }}
                        >
                          {t("new_customer")}
                        </Button>
                      </Box>
                    </Stack>
                    <Box sx={{ mt: 1 }}>
                      <CustomerSelect
                        value={selectedCustomer}
                        onChange={(selectedOption) => {
                          dispatch(setSelectedCustomer(selectedOption));
                        }}
                        loadOptions={loadCustomerOptions}
                      />
                    </Box>

                    {/* Customer Details Display */}
                    {selectedCustomer && (
                      <Box sx={{ 
                        mt: 2, 
                        p: 1.5, 
                        borderRadius: '8px',
                        bgcolor: alpha(theme.palette.grey[100], 0.4),
                        border: `1px solid ${alpha(theme.palette.divider, 0.3)}`
                      }}>
                        <Stack spacing={1}>
                          {/* Row 1: Email & Phone */}
                          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
                            {(selectedCustomer.Email || selectedCustomer.email) && (
                              <Chip
                                icon={<EmailIcon sx={{ fontSize: 16 }} />}
                                label={selectedCustomer.Email || selectedCustomer.email}
                                size="small"
                                sx={{
                                  bgcolor: alpha(theme.palette.info.main, 0.08),
                                  border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`,
                                  height: 'auto',
                                  minHeight: '28px',
                                  '& .MuiChip-label': { 
                                    px: 1, 
                                    py: 0.5,
                                    fontSize: '0.75rem', 
                                    fontWeight: 500,
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-all',
                                    display: 'block'
                                  },
                                  '& .MuiChip-icon': { color: theme.palette.info.main, marginLeft: '8px' }
                                }}
                              />
                            )}
                            {(selectedCustomer.Phone || selectedCustomer.phone) && (
                              <Chip
                                icon={<PhoneIcon sx={{ fontSize: 16 }} />}
                                label={selectedCustomer.Phone || selectedCustomer.phone}
                                size="small"
                                sx={{
                                  bgcolor: alpha(theme.palette.success.main, 0.08),
                                  border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`,
                                  '& .MuiChip-label': { px: 1, py: 0.5, fontSize: '0.75rem', fontWeight: 500 },
                                  '& .MuiChip-icon': { color: theme.palette.success.main }
                                }}
                              />
                            )}
                          </Box>

                          {/* Row 2: VAT & Peppol */}
                          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
                            {(selectedCustomer.VAT || selectedCustomer.vat || selectedCustomer.VATNumber || selectedCustomer.CustomerVAT) && (
                              <Chip
                                icon={<AccountBalanceIcon sx={{ fontSize: 16 }} />}
                                label={`VAT: ${selectedCustomer.VAT || selectedCustomer.vat || selectedCustomer.VATNumber || selectedCustomer.CustomerVAT}`}
                                size="small"
                                sx={{
                                  bgcolor: alpha(theme.palette.warning.main, 0.08),
                                  border: `1px solid ${alpha(theme.palette.warning.main, 0.2)}`,
                                  height: 'auto',
                                  minHeight: '28px',
                                  '& .MuiChip-label': { 
                                    px: 1, 
                                    py: 0.5,
                                    fontSize: '0.75rem', 
                                    fontWeight: 500,
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-all',
                                    display: 'block'
                                  },
                                  '& .MuiChip-icon': { color: theme.palette.warning.main, marginLeft: '8px' }
                                }}
                              />
                            )}
                            {(selectedCustomer.CustomerPeppolId || selectedCustomer.peppolId) && (
                              <Chip
                                icon={<SendIcon sx={{ fontSize: 16 }} />}
                                label={selectedCustomer.CustomerPeppolId || selectedCustomer.peppolId}
                                size="small"
                                sx={{
                                  bgcolor: alpha(theme.palette.secondary.main, 0.08),
                                  border: `1px solid ${alpha(theme.palette.secondary.main, 0.2)}`,
                                  height: 'auto',
                                  minHeight: '28px',
                                  '& .MuiChip-label': { 
                                    px: 1, 
                                    py: 0.5,
                                    fontSize: '0.75rem', 
                                    fontWeight: 500,
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-all',
                                    display: 'block'
                                  },
                                  '& .MuiChip-icon': { color: theme.palette.secondary.main, marginLeft: '8px' }
                                }}
                              />
                            )}
                          </Box>

                          {/* Row 3: Address */}
                          {(selectedCustomer.Address || selectedCustomer.address || 
                            selectedCustomer.Street || selectedCustomer.street || 
                            selectedCustomer.City || selectedCustomer.city) && (
                            <Box sx={{ 
                              display: 'flex', 
                              alignItems: 'flex-start', 
                              gap: 1,
                              pt: 0.5 
                            }}>
                              <LocationOnIcon sx={{ fontSize: 16, color: theme.palette.text.secondary, mt: 0.2, flexShrink: 0 }} />
                              <Typography 
                                variant="caption" 
                                color="text.secondary" 
                                sx={{ 
                                  fontSize: '0.75rem', 
                                  lineHeight: 1.5,
                                  flex: 1,
                                  wordBreak: 'break-word'
                                }}
                              >
                                {selectedCustomer.Address || selectedCustomer.address || 
                                  [
                                    selectedCustomer.Street || selectedCustomer.street,
                                    selectedCustomer.StreetNumber || selectedCustomer.streetNumber,
                                    selectedCustomer.City || selectedCustomer.city,
                                    selectedCustomer.PostalCode || selectedCustomer.postalCode,
                                    selectedCustomer.Country || selectedCustomer.country
                                  ].filter(Boolean).join(', ')}
                              </Typography>
                            </Box>
                          )}
                        </Stack>
                      </Box>
                    )}
                  </Paper>

                  {/* Product Section */}
                  <Paper
                    elevation={1}
                    sx={{
                      p: 2,
                      borderRadius: '12px',
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`
                    }}
                  >
                    <Stack direction="row" alignItems="center" spacing={2} mb={2} justifyContent="space-between">
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box sx={{
                          bgcolor: alpha(theme.palette.primary.main, 0.15),
                          p: 1,
                          borderRadius: '10px'
                        }}>
                          <InventoryIcon color="primary" />
                        </Box>
                        <Typography variant="subtitle1" fontWeight="bold" color="primary">
                          {t("product")}
                        </Typography>
                      </Box>
                      {/* ✅ TVA Inclusion Toggle and Add Product button */}
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                          {t("is_tva_included")}?
                        </Typography>
                        <Switch
                          checked={isTvaIncluded}
                          onChange={(e) => setIsTvaIncluded(e.target.checked)}
                          color="primary"
                          sx={{
                            '& .MuiSwitch-switchBase.Mui-checked': {
                              color: theme.palette.primary.main,
                            },
                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                              backgroundColor: theme.palette.primary.main,
                            }
                          }}
                        />
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          startIcon={<AddIcon />}
                          onClick={handleOpenProductDialog}
                          sx={{
                            borderRadius: '8px',
                            px: 1.5,
                            py: 0.5,
                            fontWeight: 600,
                            whiteSpace: 'nowrap',
                            fontSize: '0.813rem',
                          }}
                        >
                          {t("new_product")}
                        </Button>
                      </Box>
                    </Stack>
                    <Box>
                      <ProductSelect
                        value={selectedProduct}
                        onChange={(option) => {
                          dispatch(setSelectedProduct(option));
                          dispatch(setPrice(option?.SalePrice || ""));
                        }}
                        loadOptions={loadProductOptions}
                        quantity={quantity}
                        setQuantity={(q) => dispatch(setQuantity(q))}
                        price={price}
                        setPrice={(p) => dispatch(setPrice(p))}
                        vat={null} // ✅ Remove VAT from product selection
                        setVat={null} // ✅ Remove VAT from product selection
                        vatOptions={[]} // ✅ Remove VAT options
                        onAdd={handleAddProduct}
                        disabled={!selectedProduct || quantity <= 0 || !price || price <= 0}
                      />
                    </Box>
                  </Paper>

                  {/* Product List */}
                  {invoiceProducts.length > 0 && (
                    <Paper
                      elevation={1}
                      sx={{
                        borderRadius: '12px',
                        border: `1px solid ${alpha(theme.palette.success.main, 0.3)}`,
                        bgcolor: alpha(theme.palette.success.main, 0.05),
                        overflow: 'hidden'
                      }}
                    >
                      <Stack direction="row" alignItems="center" spacing={2} p={2}>
                        <Box sx={{
                          bgcolor: alpha(theme.palette.success.main, 0.15),
                          p: 1,
                          borderRadius: '10px'
                        }}>
                          <InventoryIcon color="success" />
                        </Box>
                        <Typography variant="subtitle1" fontWeight="bold" color="success.dark">
                          {t("products_to_be_invoiced")}
                        </Typography>
                        <Chip
                          label={`${invoiceProducts.length} ${t("items")}`}
                          color="success"
                          size="small"
                          sx={{ borderRadius: '8px', fontWeight: 'bold' }}
                        />
                      </Stack>
                      <Box sx={{ overflowX: 'auto', width: '100%' }}>
                        <Table size="small" sx={{ minWidth: 900 }}>
                          <TableHead>
                            <TableRow sx={{
                              background: alpha(theme.palette.success.main, 0.2)
                            }}>
                              <TableCell sx={{ fontWeight: "bold" }}>
                                {t("product_name")}
                              </TableCell>
                              <TableCell sx={{ fontWeight: "bold" }}>
                                {t("quantity")} ({t("editable")})
                              </TableCell>
                              <TableCell sx={{ fontWeight: "bold" }}>
                                {t("price_per_unit")}
                              </TableCell>
                              <TableCell sx={{ fontWeight: "bold" }}>
                                {t("vat_per_unit")}
                              </TableCell>
                              <TableCell sx={{ fontWeight: "bold" }}>
                                {t("total_vat")}
                              </TableCell>
                              <TableCell sx={{ fontWeight: "bold" }}>
                                {t("total_excl")}
                              </TableCell>
                              <TableCell sx={{ fontWeight: "bold" }}>
                                {t("total_incl")} ({t("editable")})
                              </TableCell>
                              <TableCell sx={{ fontWeight: "bold" }}>
                                {t("actions")}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {invoiceProducts.map((p) => {
                              const vatPerUnit = (parseFloat(p.VATAmount) / p.Quantity).toFixed(2);
                              return (
                                <TableRow key={p._rowKey} hover>
                                  <TableCell sx={{ py: 1 }}>
                                    <Typography fontWeight={500}>
                                      {p.Name}{p.SerialNumber ? ` (${p.SerialNumber})` : ""}
                                    </Typography>
                                  </TableCell>
                                  <TableCell sx={{ py: 1 }}>
                                    <TextField
                                      type="number"
                                      value={p.Quantity}
                                      onChange={(e) => {
                                        const newQuantity = parseFloat(e.target.value) || 0;
                                        if (newQuantity <= 0) return; // Prevent zero or negative quantity
                                        const updatedProducts = invoiceProducts.map((prod) => {
                                          if (prod._rowKey === p._rowKey) {
                                            // Recalculate based on new quantity
                                            const pricePerUnit = parseFloat(prod.Price);
                                            const newTotalExcl = pricePerUnit * newQuantity;
                                            const vatRate = invoiceVAT / 100;
                                            const newVATAmount = newTotalExcl * vatRate;
                                            const newTotalIncl = newTotalExcl + newVATAmount;
                                            return {
                                              ...prod,
                                              Quantity: newQuantity,
                                              TotalExcl: newTotalExcl.toFixed(2),
                                              VATAmount: newVATAmount.toFixed(2),
                                              TotalIncl: newTotalIncl.toFixed(2),
                                              TotalVAT: newVATAmount.toFixed(2),
                                              TotalInclVAT: newTotalIncl.toFixed(2),
                                            };
                                          }
                                          return prod;
                                        });
                                        setInvoiceProducts(updatedProducts);
                                      }}
                                      size="small"
                                      inputProps={{ min: 1, step: 1 }}
                                      sx={{
                                        width: '80px',
                                        '& .MuiOutlinedInput-root': {
                                          borderRadius: '8px',
                                          fontWeight: 600,
                                        },
                                        '& input': {
                                          py: 0.5,
                                          px: 1,
                                          textAlign: 'center',
                                        }
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell sx={{ py: 1 }}>
                                    <Typography fontWeight={500}>€{p.Price}</Typography>
                                  </TableCell>
                                  <TableCell sx={{ py: 1 }}>
                                    <Typography fontWeight={500}>€{vatPerUnit}</Typography>
                                  </TableCell>
                                  <TableCell sx={{ py: 1 }}>
                                    <Typography fontWeight={500} color="warning.main">€{p.VATAmount}</Typography>
                                  </TableCell>
                                  <TableCell sx={{ py: 1 }}>
                                    <Typography fontWeight={600} color="success.main">
                                      €{p.TotalExcl}
                                    </Typography>
                                  </TableCell>
                                  <TableCell sx={{ py: 1 }}>
                                    <TextField
                                      type="number"
                                      value={p.TotalIncl}
                                      onChange={(e) => {
                                        const newTotalIncl = parseFloat(e.target.value) || 0;
                                        const updatedProducts = invoiceProducts.map((prod) => {
                                          if (prod._rowKey === p._rowKey) {
                                            // Recalculate based on new total
                                            const vatRate = invoiceVAT / 100;
                                            const newTotalExcl = newTotalIncl / (1 + vatRate);
                                            const newVATAmount = newTotalIncl - newTotalExcl;
                                            const newPrice = (newTotalExcl / prod.Quantity).toFixed(2);
                                            
                                            // Check MinSalePrice validation
                                            const minPrice = prod.MinSalePrice || 0;
                                            if (minPrice > 0 && parseFloat(newPrice) < minPrice) {
                                              toast.error(`Price €${newPrice} is below minimum sale price €${minPrice.toFixed(2)} for ${prod.Name}`);
                                              return prod; // Don't update if below minimum
                                            }
                                            
                                            return {
                                              ...prod,
                                              TotalIncl: newTotalIncl.toFixed(2),
                                              TotalExcl: newTotalExcl.toFixed(2),
                                              VATAmount: newVATAmount.toFixed(2),
                                              TotalVAT: newVATAmount.toFixed(2),
                                              TotalInclVAT: newTotalIncl.toFixed(2),
                                              Price: newPrice,
                                            };
                                          }
                                          return prod;
                                        });
                                        setInvoiceProducts(updatedProducts);
                                      }}
                                      size="small"
                                      sx={{
                                        width: '100px',
                                        '& .MuiOutlinedInput-root': {
                                          borderRadius: '8px',
                                          fontWeight: 600,
                                        },
                                        '& input': {
                                          py: 0.5,
                                          px: 1,
                                        }
                                      }}
                                      InputProps={{
                                        startAdornment: <Box sx={{ mr: 0.5, color: 'primary.main' }}>€</Box>,
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell sx={{ py: 1 }}>
                                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                                      <Button
                                        onClick={() => handleOpenSerialNumberDialog(p)}
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        sx={{
                                          minWidth: '45px',
                                          px: 1,
                                          py: 0.5,
                                          fontSize: '0.75rem',
                                          fontWeight: 600,
                                          borderRadius: '8px',
                                          transition: 'all 0.2s',
                                          '&:hover': {
                                            bgcolor: alpha(theme.palette.primary.main, 0.1),
                                            transform: 'scale(1.05)'
                                          }
                                        }}
                                      >
                                        SN
                                      </Button>
                                      <IconButton
                                        onClick={() => handleRemoveProduct(p._rowKey)}
                                        color="error"
                                        size="small"
                                        sx={{
                                          transition: 'all 0.2s',
                                          '&:hover': {
                                            bgcolor: alpha(theme.palette.error.main, 0.1),
                                            transform: 'scale(1.1)'
                                          }
                                        }}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </Box>
                    </Paper>
                  )}

                  {/* Outstanding Invoices - moved under Product List */}
                  {selectedCustomer && outstandingInvoices.length > 0 && showOutstanding && (
                    <Paper
                      elevation={1}
                      sx={{
                        p: 2,
                        borderRadius: '12px',
                        border: `1px solid ${alpha(theme.palette.warning.main, 0.3)}`,
                        bgcolor: alpha(theme.palette.warning.main, 0.05)
                      }}
                    >
                      <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                        <Box sx={{
                          bgcolor: alpha(theme.palette.warning.main, 0.15),
                          p: 1,
                          borderRadius: '10px'
                        }}>
                          <ReceiptLongIcon color="warning" />
                        </Box>
                        <Typography variant="subtitle1" fontWeight="bold" color="warning.dark">
                          {t("outstanding_invoices")}
                        </Typography>
                        <Chip
                          label={`${outstandingInvoices.length}`}
                          color="warning"
                          size="small"
                          sx={{ borderRadius: '8px', fontWeight: 'bold' }}
                        />
                      </Stack>
                      <Box sx={{ overflowX: 'auto', width: '100%' }}>
                        <Table size="small" sx={{ minWidth: 500 }}>
                          <TableHead>
                            <TableRow sx={{
                              background: alpha(theme.palette.warning.main, 0.2)
                            }}>
                              <TableCell sx={{ fontWeight: "bold" }}>
                                {t("invoice_number")}
                              </TableCell>
                              <TableCell align="right" sx={{ fontWeight: "bold" }}>
                                {t("total_amount")}
                              </TableCell>
                              <TableCell align="center" sx={{ fontWeight: "bold" }}>
                                {t("add_to_invoice")}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {outstandingInvoices.map((inv) => (
                              <TableRow key={inv.Id} hover>
                                <TableCell sx={{ py: 1 }}>
                                  <Typography fontWeight={500}>
                                    {inv.InvoiceNumber}
                                  </Typography>
                                </TableCell>
                                <TableCell align="right" sx={{ py: 1 }}>
                                  <Chip
                                    label={`€${inv.InvoiceDueAmount}`}
                                    color="warning"
                                    size="small"
                                    variant="outlined"
                                    sx={{ borderRadius: '8px', fontWeight: 'medium' }}
                                  />
                                </TableCell>
                                <TableCell align="center" sx={{ py: 1 }}>
                                  <Checkbox
                                    checked={selectedInvoices.some((i) => i.Id === inv.Id)}
                                    onChange={() => handleInvoiceToggle(inv)}
                                    color="warning"
                                    sx={{
                                      '&.Mui-checked': {
                                        color: theme.palette.warning.main,
                                      }
                                    }}
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Box>
                    </Paper>
                  )}

                  {/* Custom Text */}
                  <Paper
                    elevation={1}
                    sx={{
                      p: 2,
                      borderRadius: '12px',
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`
                    }}
                  >
                    <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                      <Box sx={{
                        bgcolor: alpha(theme.palette.primary.main, 0.15),
                        p: 1,
                        borderRadius: '10px'
                      }}>
                        <NotesIcon color="primary" />
                      </Box>
                      <Typography variant="subtitle1" fontWeight="bold" color="primary">
                        {t("custom_text")}
                      </Typography>
                    </Stack>
                    {invoiceNoteTemplates.length > 0 && (
                      <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                        <InputLabel>{t('select_template') || 'Select template'}</InputLabel>
                        <Select
                          value={selectedInvoiceNoteTemplate}
                          label={t('select_template') || 'Select template'}
                          onChange={(e) => handleInvoiceTemplateSelect(e.target.value)}
                        >
                          <MenuItem value=""><em>{t('none') || 'None'}</em></MenuItem>
                          {invoiceNoteTemplates.map((tmpl) => (
                            <MenuItem key={tmpl.Id} value={tmpl.Id}>{tmpl.TemplateName}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                    <Box sx={{
                      '.ql-toolbar': {
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                        border: `1px solid ${alpha(theme.palette.primary.main, 0.2)} !important`,
                        borderBottom: 'none !important',
                        backgroundColor: alpha(theme.palette.background.paper, 0.7)
                      },
                      '.ql-container': {
                        borderBottomLeftRadius: '8px',
                        borderBottomRightRadius: '8px',
                        border: `1px solid ${alpha(theme.palette.primary.main, 0.2)} !important`,
                        backgroundColor: alpha(theme.palette.background.paper, 0.5),
                        minHeight: '220px'
                      },
                      '.ql-editor': {
                        minHeight: '220px',
                        maxHeight: '400px',
                        overflowY: 'auto'
                      }
                    }}>
                      <ReactQuill
                        value={customText}
                        onChange={handleCustomTextChange}
                        style={{ marginBottom: 16 }}
                      />
                    </Box>
                    <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
                      <LinearProgress
                        variant="determinate"
                        value={(customTextLength / MAX_CUSTOM_TEXT_LENGTH) * 100}
                        sx={{
                          flexGrow: 1,
                          height: 8,
                          borderRadius: 4,
                          bgcolor: alpha(theme.palette.grey[300], 0.5)
                        }}
                        color={customTextLength >= MAX_CUSTOM_TEXT_LENGTH ? "error" : "primary"}
                      />
                      <Typography
                        variant="caption"
                        color={customTextLength >= MAX_CUSTOM_TEXT_LENGTH ? "error" : "text.secondary"}
                        sx={{ fontWeight: 'medium', whiteSpace: 'nowrap' }}
                      >
                        {customTextLength} / {MAX_CUSTOM_TEXT_LENGTH}
                      </Typography>
                    </Box>
                  </Paper>
                </Stack>
              </Grid>

              {/* Right Column: Payment & Discount + Action Buttons */}
              <Grid item xs={12} md={4}>
                <Card
                  elevation={3}
                  sx={{
                    borderRadius: '16px',
                    background: alpha(theme.palette.info.light, 0.05),
                    mb: 2
                  }}
                >
                  <CardHeader
                    title={
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{
                          bgcolor: alpha(theme.palette.info.main, 0.15),
                          p: 1.2,
                          borderRadius: '12px',
                          mr: 2
                        }}>
                          <PaymentIcon color="info" fontSize="large" />
                        </Box>
                        <Typography variant="h6" fontWeight="bold" color="info.main">
                          {t("payment_and_discount")}
                        </Typography>
                      </Box>
                    }
                    sx={{
                      background: alpha(theme.palette.info.light, 0.1),
                      borderBottom: `1px solid ${alpha(theme.palette.divider, 0.5)}`
                    }}
                  />
                  <CardContent>
                    <Stack spacing={3}>
                      {/* Payment Section */}
                      <Paper
                        elevation={1}
                        sx={{
                          p: 2,
                          borderRadius: '12px',
                          border: `1px solid ${alpha(theme.palette.info.main, 0.3)}`,
                          bgcolor: 'white'
                        }}
                      >
                        <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                          <Box sx={{
                            bgcolor: alpha(theme.palette.info.main, 0.15),
                            p: 1,
                            borderRadius: '10px'
                          }}>
                            <PaymentIcon color="info" />
                          </Box>
                          <Typography variant="subtitle1" fontWeight="bold" color="info.dark">
                            {t("payment")}
                          </Typography>
                        </Stack>
                        
                        {/* ✅ Add Invoice Date Picker */}
                        <Box sx={{ mb: 2 }}>
                          <TextField
                            fullWidth
                            type="date"
                            label={t("invoice_date")}
                            value={invoiceDate.toISOString().slice(0, 10)}
                            onChange={(e) => setInvoiceDate(new Date(e.target.value))}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              max: new Date().toISOString().slice(0, 10), // ✅ Prevent future dates
                            }}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '10px'
                              }
                            }}
                          />
                        </Box>

                        {/* ✅ Add Payment Method Dropdown */}
                        <Box sx={{ mb: 2 }}>
                          <FormControl fullWidth size="medium" error={paymentMethodError} disabled={useMultiplePayments}>
                            <InputLabel id="payment-method-label" shrink>{t("payment_method")}</InputLabel>
                            <Select
                              labelId="payment-method-label"
                              value={paymentMethod}
                              label={t("payment_method")}
                              notched
                              onChange={(e) => {
                                const selectedValue = e.target.value;
                                setPaymentMethod(selectedValue);
                                setPaymentMethodError(false);
                                
                                // ✅ Auto-enable multiple payment methods if MULTIPLE is selected
                                const isMultipleMethod = paymentMethodOptions.find(
                                  opt => opt.value === selectedValue && 
                                  (opt.value === "MULTIPLE" || opt.label === "MULTIPLE" || opt.label?.toLowerCase() === "multiple")
                                );
                                
                                if (isMultipleMethod) {
                                  setUseMultiplePayments(true);
                                }
                              }}
                              sx={{ borderRadius: '10px' }}
                              displayEmpty
                            >
                              <MenuItem value="" disabled>
                                <em>{t("select_payment_method") || "Select Payment Method"}</em>
                              </MenuItem>
                              {paymentMethodOptions.map((method) => (
                                <MenuItem key={method.value} value={method.value}>
                                  {method.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {paymentMethodError && !useMultiplePayments && (
                            <Box sx={{ mt: 1 }}>
                              <Typography variant="caption" color="error" sx={{ display: 'block' }}>
                                {t("please_select_payment_method") || "Please select a payment method"}
                              </Typography>
                            </Box>
                          )}
                        </Box>

                        {/* ✅ Toggle for multiple payment methods */}
                        <Box sx={{ mb: 2 }}>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={useMultiplePayments}
                                onChange={(e) => {
                                  setUseMultiplePayments(e.target.checked);
                                  setPaymentMethodError(false); // Clear payment method error
                                  if (!e.target.checked) {
                                    setPaymentMethods([]);
                                  }
                                }}
                                color="primary"
                              />
                            }
                            label={t("use_multiple_payment_methods") || "Use Multiple Payment Methods"}
                          />
                        </Box>

                        {/* ✅ Show either single or multiple payment section */}
                        {!useMultiplePayments ? (
                          <PaymentSection
                            totalIncl={grandTotal}
                            invoicePaidAmount={invoicePaidAmount}
                            setInvoicePaidAmount={setInvoicePaidAmount}
                            error={paidAmountError}
                            onFocus={() => setPaidAmountError(false)}
                            disabled={grandTotal <= 0}
                            onFullPayment={handleFullPayment}
                          />
                        ) : (
                          <MultiplePaymentMethodsSection
                            paymentMethods={paymentMethods}
                            onPaymentMethodsChange={setPaymentMethods}
                            totalAmount={grandTotal}
                            disabled={grandTotal <= 0}
                            paymentMethodOptions={paymentMethodOptions}
                          />
                        )}

                        {/* ✅ Conditional Due Date Field - Only show if not fully paid */}
                        {parseFloat(invoicePaidAmount || 0) < grandTotal && (
                          <Box sx={{ mt: 2 }}>
                            <TextField
                              fullWidth
                              type="date"
                              label={t("due_date")}
                              value={dueDate.toISOString().slice(0, 10)}
                              onChange={(e) => setDueDate(new Date(e.target.value))}
                              InputLabelProps={{ shrink: true }}
                              inputProps={{
                                min: new Date().toISOString().slice(0, 10), // ✅ Due date should be in future
                              }}
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: '10px'
                                }
                              }}
                            />
                          </Box>
                        )}
                      </Paper>

                      {/* Discount Section - DISABLED */}
                      <Paper
                        elevation={1}
                        sx={{
                          p: 2,
                          borderRadius: '12px',
                          border: `1px solid ${alpha(theme.palette.grey[400], 0.3)}`,
                          bgcolor: 'grey.50',
                          opacity: 0.6,
                          pointerEvents: 'none'
                        }}
                      >
                        <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                          <Box sx={{
                            bgcolor: alpha(theme.palette.grey[400], 0.15),
                            p: 1,
                            borderRadius: '10px'
                          }}>
                            <DiscountIcon color="disabled" />
                          </Box>
                          <Typography variant="subtitle1" fontWeight="bold" color="text.disabled">
                            {t("discount")} ({t("coming_soon") || "Coming Soon"})
                          </Typography>
                        </Stack>
                        <Grid container spacing={2} alignItems="center">
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="medium" disabled>
                              <InputLabel id="discount-type-label">{t("type")}</InputLabel>
                              <Select
                                labelId="discount-type-label"
                                value={discountType}
                                label={t("type")}
                                onChange={(e) => setDiscountType(e.target.value)}
                                sx={{ borderRadius: '10px' }}
                                disabled
                              >
                                <MenuItem value="percentage">{t("percentage")}</MenuItem>
                                <MenuItem value="fixed">{t("fixed_amount")}</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              fullWidth
                              type="number"
                              label={t("value")}
                              value={discountValue}
                              onChange={(e) => setDiscountValue(e.target.value)}
                              placeholder={discountType === "percentage" ? t("eg_10") : t("eg_50")}
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  borderRadius: '10px'
                                }
                              }}
                              InputProps={{
                                startAdornment: discountType === "percentage" ? null : <Box sx={{ mr: 1 }}>€</Box>,
                                endAdornment: discountType === "percentage" ? <Box sx={{ ml: 1 }}>%</Box> : null
                              }}
                              disabled
                            />
                          </Grid>
                        </Grid>
                      </Paper>

                      {/* Invoice-Level VAT Section - Add this entire block */}
                      <Paper
                        elevation={1}
                        sx={{
                          p: 2,
                          borderRadius: '12px',
                          border: `1px solid ${alpha(theme.palette.info.main, 0.3)}`,
                          bgcolor: 'white'
                        }}
                      >
                        <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                          <Box sx={{
                            bgcolor: alpha(theme.palette.info.main, 0.15),
                            p: 1,
                            borderRadius: '10px'
                          }}>
                            <CalculateIcon color="info" />
                          </Box>
                          <Typography variant="subtitle1" fontWeight="bold" color="info.dark">
                            {t("vat_rate")}
                          </Typography>
                        </Stack>
                        <FormControl fullWidth size="medium">
                          <InputLabel id="invoice-vat-label">{t("vat_percentage")}</InputLabel>
                          <Select
                            labelId="invoice-vat-label"
                            value={invoiceVAT}
                            label={t("vat_percentage")}
                            onChange={(e) => setInvoiceVAT(e.target.value)}
                            sx={{ borderRadius: '10px' }}
                          >
                            <MenuItem value={0}>0%</MenuItem>
                            <MenuItem value={6}>6%</MenuItem>
                            <MenuItem value={12}>12%</MenuItem>
                            <MenuItem value={21}>21%</MenuItem>
                          </Select>
                        </FormControl>
                      </Paper>

                      {/* Total Summary - Update to show invoice-level VAT */}
                      <Paper
                        elevation={1}
                        sx={{
                          p: 2,
                          borderRadius: '12px',
                          border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
                          bgcolor: alpha(theme.palette.primary.main, 0.03)
                        }}
                      >
                        <Stack spacing={2}>
                          <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            p: 1.5,
                            bgcolor: 'white',
                            borderRadius: '10px',
                            border: `1px solid ${alpha(theme.palette.divider, 0.2)}`
                          }}>
                            <Typography variant="subtitle1">{t("subtotal")}:</Typography>
                            <Typography variant="subtitle1" fontWeight="bold">
                              €{totalExcl.toFixed(2)}
                            </Typography>
                          </Box>
                          <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            p: 1.5,
                            bgcolor: 'white',
                            borderRadius: '10px',
                            border: `1px solid ${alpha(theme.palette.divider, 0.2)}`
                          }}>
                            <Typography variant="subtitle1">{t("vat")} ({invoiceVAT}%):</Typography>
                            <Typography variant="subtitle1" fontWeight="bold">
                              €{totalVAT.toFixed(2)}
                            </Typography>
                          </Box>
                          <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            p: 1.5,
                            bgcolor: 'white',
                            borderRadius: '10px',
                            border: `1px solid ${alpha(theme.palette.divider, 0.2)}`
                          }}>
                            <Typography variant="subtitle1" color="success.main">{t("discount")}:</Typography>
                            <Typography variant="subtitle1" fontWeight="bold" color="success.main">
                              -€{discountAmount.toFixed(2)}
                            </Typography>
                          </Box>
                          <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            p: 2,
                            bgcolor: alpha(theme.palette.primary.main, 0.1),
                            borderRadius: '10px',
                            border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`
                          }}>
                            <Typography variant="h6" fontWeight="bold" color="primary">
                              {t("grand_total")}:
                            </Typography>
                            <Typography variant="h6" fontWeight="bold" color="primary">
                              €{grandTotal.toFixed(2)}
                            </Typography>
                          </Box>
                        </Stack>
                      </Paper>

                      {/* ✅ Peppol Toggle Section - Add this entire block */}
                      {selectedCustomer?.CustomerPeppolId && (
                        <Paper
                          elevation={1}
                          sx={{
                            p: 2,
                            borderRadius: '12px',
                            border: `1px solid ${alpha(theme.palette.success.main, 0.3)}`,
                            bgcolor: alpha(theme.palette.success.main, 0.05)
                          }}
                        >
                          <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                              <Box sx={{
                                bgcolor: alpha(theme.palette.success.main, 0.15),
                                p: 1,
                                borderRadius: '10px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}>
                                <SendIcon color="success" fontSize="small" />
                              </Box>
                              <Box>
                                <Typography variant="body2" fontWeight="bold" color="success.dark">
                                  {t("send_invoice_on_peppol")}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  Peppol ID: {selectedCustomer.CustomerPeppolId}
                                </Typography>
                              </Box>
                            </Box>
                            <Switch
                              checked={isSendOnPeppol}
                              onChange={(e) => setIsSendOnPeppol(e.target.checked)}
                              color="success"
                              sx={{
                                '& .MuiSwitch-switchBase.Mui-checked': {
                                  color: theme.palette.success.main,
                                },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                  backgroundColor: theme.palette.success.main,
                                }
                              }}
                            />
                          </Stack>
                        </Paper>
                      )}

                      {/* ✅ Email Toggle Section - Visible but disabled */}
                      {selectedCustomer?.Email && (
                        <Paper
                          elevation={1}
                          sx={{
                            p: 2,
                            borderRadius: '12px',
                            border: `1px solid ${alpha(theme.palette.info.main, 0.3)}`,
                            bgcolor: alpha(theme.palette.info.main, 0.05),
                            opacity: 0.6,
                            cursor: 'not-allowed'
                          }}
                        >
                          <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                              <Box sx={{
                                bgcolor: alpha(theme.palette.info.main, 0.15),
                                p: 1,
                                borderRadius: '10px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}>
                                <EmailIcon color="info" fontSize="small" />
                              </Box>
                              <Box>
                                <Typography variant="body2" fontWeight="bold" color="info.dark">
                                  {t("send_invoice_via_email")}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  Email: {selectedCustomer.Email}
                                </Typography>
                                <Typography variant="caption" display="block" color="text.disabled" sx={{ fontStyle: 'italic', mt: 0.5 }}>
                                  (Currently disabled)
                                </Typography>
                              </Box>
                            </Box>
                            <Switch
                              checked={isEmailSend}
                              onChange={(e) => {
                                // ⛔ FEATURE DISABLED: Prevent toggle
                                toast.info('Email functionality is currently disabled');
                              }}
                              disabled={true}
                              color="info"
                              sx={{
                                '& .MuiSwitch-switchBase.Mui-checked': {
                                  color: theme.palette.info.main,
                                },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                  backgroundColor: theme.palette.info.main,
                                }
                              }}
                            />
                          </Stack>
                        </Paper>
                      )}

                      {/* Action Buttons - this should already exist below */}
                      <Box>
                        <Grid container spacing={2} direction="column" alignItems="stretch">
                          {invoiceProducts.length === 0 && (
                            <Grid item xs={12} mb={1}>
                              <Box sx={{
                                p: 2,
                                borderRadius: '10px',
                                bgcolor: alpha(theme.palette.error.main, 0.08),
                                border: `1px solid ${alpha(theme.palette.error.main, 0.2)}`,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}>
                                <Typography
                                  variant="body1"
                                  color="error"
                                  textAlign="center"
                                  fontWeight="medium"
                                >
                                  {t("please_add_at_least_one_product")}
                                </Typography>
                              </Box>
                            </Grid>
                          )}

                          {/* Attach PDF Toggle */}
                          <Grid item xs={12}>
                            <Paper
                              elevation={1}
                              sx={{
                                p: 2,
                                borderRadius: '12px',
                                border: `1px solid ${alpha(theme.palette.info.main, 0.3)}`,
                                bgcolor: alpha(theme.palette.info.main, 0.05)
                              }}
                            >
                              <Stack direction="row" alignItems="center" justifyContent="space-between">
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                  <Box sx={{
                                    bgcolor: alpha(theme.palette.info.main, 0.15),
                                    p: 1,
                                    borderRadius: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}>
                                    <PictureAsPdfIcon color="info" fontSize="small" />
                                  </Box>
                                  <Box>
                                    <Typography variant="body2" fontWeight="bold" color="info.dark">
                                      {t("attach_pdf_to_invoice")}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                      {t("send_invoice_as_pdf_attachment")}
                                    </Typography>
                                  </Box>
                                </Box>
                                <Switch
                                  checked={attachPdf}
                                  onChange={(e) => setAttachPdf(e.target.checked)}
                                  disabled={!isSendOnPeppol}
                                  color="info"
                                  sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                      color: theme.palette.info.main,
                                    },
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                      backgroundColor: theme.palette.info.main,
                                    }
                                  }}
                                />
                              </Stack>
                            </Paper>
                          </Grid>

                          {/* Preview Invoice button on top */}
                          <Grid item xs={12}>
                            <Button
                              variant="outlined"
                              fullWidth
                              size="large"
                              startIcon={<PreviewIcon />}
                              onClick={async () => {
                                try {
                                  // ✅ Check if store info is loaded
                                  if (!storeInfo) {
                                    toast.warning('Loading store information...');
                                    await new Promise(resolve => setTimeout(resolve, 1000));
                                    if (!storeInfo) {
                                      toast.error('Store information not available. Please refresh the page.');
                                      return;
                                    }
                                  }

                                  const tempDiv = document.createElement("div");
                                  tempDiv.innerHTML = getFilledTemplate();
                                  
                                  // Style for proper rendering
                                  tempDiv.style.position = "absolute";
                                  tempDiv.style.left = "-9999px";
                                  tempDiv.style.width = "794px"; // A4 width in pixels at 96dpi
                                  tempDiv.style.background = "white";
                                  document.body.appendChild(tempDiv);

                                  // Wait for images to load
                                  const images = tempDiv.getElementsByTagName('img');
                                  await Promise.all(
                                    Array.from(images).map(img => {
                                      if (img.complete) return Promise.resolve();
                                      return new Promise(resolve => {
                                        img.onload = resolve;
                                        img.onerror = resolve;
                                      });
                                    })
                                  );

                                  // Generate canvas
                                  const canvas = await html2canvas(tempDiv, {
                                    scale: 2,
                                    useCORS: true,
                                    logging: false,
                                    width: 794,
                                    windowWidth: 794,
                                    backgroundColor: '#ffffff'
                                  });

                                  document.body.removeChild(tempDiv);

                                  // Create PDF
                                  const imgData = canvas.toDataURL('image/png');
                                  const pdf = new jsPDF({
                                    orientation: 'portrait',
                                    unit: 'mm',
                                    format: 'a4'
                                  });

                                  const pdfWidth = pdf.internal.pageSize.getWidth();
                                  const pdfHeight = pdf.internal.pageSize.getHeight();
                                  
                                  // Calculate image dimensions to fit A4
                                  const imgWidth = pdfWidth;
                                  const imgHeight = (canvas.height * pdfWidth) / canvas.width;

                                  // If content is taller than one page, scale it down
                                  if (imgHeight > pdfHeight) {
                                    const scaledWidth = (canvas.width * pdfHeight) / canvas.height;
                                    const scaledHeight = pdfHeight;
                                    pdf.addImage(imgData, 'PNG', 0, 0, scaledWidth, scaledHeight);
                                  } else {
                                    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
                                  }

                                  // Open in new tab
                                  const pdfBlob = pdf.output('blob');
                                  const pdfUrl = URL.createObjectURL(pdfBlob);
                                  window.open(pdfUrl, '_blank');
                                } catch (error) {
                                  console.error('PDF generation error:', error);
                                  toast.error(t("failed_to_generate_pdf"));
                                }
                              }}
                              disabled={!selectedCustomer || invoiceProducts.length === 0}
                              sx={{
                                py: 1.5,
                                borderRadius: '12px',
                                borderWidth: '2px',
                                borderColor: theme.palette.primary.main,
                                fontSize: '1rem',
                                textTransform: 'none',
                                fontWeight: 'bold',
                                mb: 2,
                                '&:hover': {
                                  borderWidth: '2px',
                                  backgroundColor: alpha(theme.palette.primary.main, 0.04)
                                }
                              }}
                            >
                              {t("preview_invoice")}
                            </Button>
                          </Grid>

                          {/* Create Invoice button */}
                          <Grid item xs={12}>
                            <Button
                              variant="contained"
                              fullWidth
                              size="large"
                              startIcon={creatingInvoice ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : <SaveIcon />}
                              onClick={handleAddInvoiceAndGeneratePDF}
                              disabled={!selectedCustomer || invoiceProducts.length === 0 || creatingInvoice}
                              sx={{
                                py: 1.5,
                                borderRadius: '12px',
                                background: "linear-gradient(45deg, #3b82f6 20%, #6366f1 90%)",
                                boxShadow: '0 8px 20px rgba(99, 102, 241, 0.3)',
                                fontSize: '1rem',
                                textTransform: 'none',
                                fontWeight: 'bold',
                                transition: 'all 0.3s',
                                '&:hover': {
                                  transform: creatingInvoice ? 'none' : 'translateY(-2px)',
                                  boxShadow: '0 10px 25px rgba(99, 102, 241, 0.4)'
                                },
                                '&:disabled': {
                                  background: 'linear-gradient(45deg, #9ca3af 20%, #6b7280 90%)',
                                }
                              }}
                            >
                              {creatingInvoice ? (isEditMode ? t("updating_invoice") : t("creating_invoice")) : (isEditMode ? t("update_invoice") : t("create_invoice"))}
                            </Button>
                          </Grid>
                        </Grid>
                      </Box>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>

      {/* ✅ Serial Number Dialog */}
      <Dialog
        open={serialNumberDialog.open}
        onClose={handleCloseSerialNumberDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          },
        }}
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            py: 2.5,
          }}
        >
          <QrCodeIcon sx={{ fontSize: 32 }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {t("add_serial_number")}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ mt: 3, pb: 2 }}>
          {serialNumberDialog.product && (
            <Box>
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  mb: 3,
                  backgroundColor: '#f8f9fa',
                  borderRadius: 2,
                  border: '1px solid rgba(102, 126, 234, 0.2)',
                }}
              >
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  {t("product")}
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  {serialNumberDialog.product.Name}
                </Typography>
              </Paper>
              <TextField
                fullWidth
                label={t("serial_number")}
                value={serialNumberDialog.serialNumber}
                onChange={(e) =>
                  setSerialNumberDialog({
                    ...serialNumberDialog,
                    serialNumber: e.target.value,
                  })
                }
                placeholder={t("enter_serial_number")}
                autoFocus
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '10px',
                  },
                }}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
          <Button
            onClick={handleCloseSerialNumberDialog}
            variant="outlined"
            sx={{
              textTransform: 'none',
              px: 3,
              borderRadius: 2,
              fontWeight: 600,
            }}
          >
            {t("cancel")}
          </Button>
          <Button
            onClick={handleSaveSerialNumber}
            variant="contained"
            sx={{
              textTransform: 'none',
              px: 3,
              borderRadius: 2,
              fontWeight: 600,
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #5568d3 0%, #6a3f91 100%)',
              },
            }}
          >
            {t("save")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ✅ Confirmation Dialog */}
      <Dialog
        open={showConfirmDialog}
        onClose={() => !creatingInvoice && setShowConfirmDialog(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          },
        }}
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            py: 2.5,
          }}
        >
          <ReceiptLongIcon sx={{ fontSize: 32 }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {isEditMode ? t("confirm_invoice_update") : t("confirm_invoice_creation")}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ mt: 3, pb: 2 }}>
          <Typography variant="body1" sx={{ mb: 3, fontWeight: 500 }}>
            {isEditMode ? t("are_you_sure_update_invoice") : t("are_you_sure_create_invoice")}
          </Typography>
          
          {/* Invoice Summary */}
          <Paper elevation={0} sx={{ p: 2, bgcolor: alpha(theme.palette.primary.main, 0.05), borderRadius: 2, mb: 2 }}>
            <Typography variant="subtitle2" color="primary" sx={{ mb: 2, fontWeight: 'bold' }}>
              {t("invoice_summary")}
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="body2" color="text.secondary">{t("invoice_number")}:</Typography>
                <Typography variant="body1" fontWeight="600">{invoiceNumber}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" color="text.secondary">{t("customer")}:</Typography>
                <Typography variant="body1" fontWeight="600">{selectedCustomer?.Name || 'N/A'}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" color="text.secondary">{t("total_items")}:</Typography>
                <Typography variant="body1" fontWeight="600">{invoiceProducts.length}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" color="text.secondary">{t("grand_total")}:</Typography>
                <Typography variant="body1" fontWeight="600" color="primary">€{grandTotal.toFixed(2)}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" color="text.secondary">{t("paid_amount")}:</Typography>
                <Typography variant="body1" fontWeight="600">€{(parseFloat(invoicePaidAmount) || 0).toFixed(2)}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" color="text.secondary">{t("due_amount")}:</Typography>
                <Typography variant="body1" fontWeight="600" color="error">€{(grandTotal - (parseFloat(invoicePaidAmount) || 0)).toFixed(2)}</Typography>
              </Grid>
              <Grid item xs={12}>
                {isSendOnPeppol ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                    <SendIcon color="success" fontSize="small" />
                    <Typography variant="body2" color="success.main" fontWeight="600">
                      {t("will_send_on_peppol")}
                    </Typography>
                  </Box>
                ) : (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                    <SendIcon color="warning" fontSize="small" />
                    <Typography variant="body2" color="warning.main" fontWeight="600">
                      {t("will_not_send_on_peppol")}
                    </Typography>
                  </Box>
                )}
              </Grid>
              {attachPdf && (
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <PictureAsPdfIcon color="info" fontSize="small" />
                    <Typography variant="body2" color="info.main" fontWeight="600">
                      {t("pdf_will_be_attached")}
                    </Typography>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Paper>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
          <Button
            onClick={() => setShowConfirmDialog(false)}
            variant="outlined"
            disabled={creatingInvoice}
            sx={{
              textTransform: 'none',
              px: 3,
              borderRadius: 2,
              fontWeight: 600,
            }}
          >
            {t("cancel")}
          </Button>
          <Button
            onClick={handleConfirmCreateInvoice}
            variant="contained"
            disabled={creatingInvoice}
            startIcon={creatingInvoice ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : <CheckCircle />}
            sx={{
              textTransform: 'none',
              px: 3,
              borderRadius: 2,
              fontWeight: 600,
              background: 'linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)',
              },
            }}
          >
            {creatingInvoice ? (isEditMode ? t("updating_invoice") : t("creating_invoice")) : (isEditMode ? t("yes_update_invoice") : t("yes_create_invoice"))}
          </Button>
        </DialogActions>
      </Dialog>

      <InvoicePreviewDialog
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        html={previewHtml}
      />

      {/* ✅ Add Customer Dialog */}
      <Dialog
        open={openCustomerDialog}
        onClose={handleCloseCustomerDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          },
        }}
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            py: 2.5,
          }}
        >
          <PersonIcon sx={{ fontSize: 32 }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {t("add_new_customer")}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ mt: 3, pb: 2 }}>
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" color="primary" fontWeight="600" sx={{ mb: 2 }}>
              {t("basic_information")}
            </Typography>
            <Grid container spacing={2}>
              {/* VAT Number with Validate button */}
              <Grid item xs={12} sm={6}>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <TextField
                    fullWidth
                    label={t("vat_number") + " *"}
                    value={newCustomerData.vat || ''}
                    onChange={(e) => {
                      setNewCustomerData({ ...newCustomerData, vat: e.target.value });
                      if (customerErrors.vat) {
                        setCustomerErrors(prev => ({ ...prev, vat: undefined }));
                      }
                    }}
                    error={Boolean(customerErrors.vat)}
                    helperText={customerErrors.vat || t("vat_search_hint") || ''}
                    sx={{ 
                      flex: 1,
                      '& .MuiOutlinedInput-root': { borderRadius: '10px' } 
                    }}
                  />
                  <Button
                    variant="contained"
                    onClick={handleVATLookup}
                    disabled={vatSearching || !newCustomerData.vat}
                    sx={{
                      minWidth: 90,
                      height: 56,
                      borderRadius: '10px',
                      textTransform: 'none'
                    }}
                  >
                    {vatSearching ? <CircularProgress size={20} color="inherit" /> : t("validate")}
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label={t("company_name") + " *"}
                  value={newCustomerData.companyName || ''}
                  onChange={(e) => {
                    setNewCustomerData({ ...newCustomerData, companyName: e.target.value });
                    if (customerErrors.companyName) {
                      setCustomerErrors(prev => ({ ...prev, companyName: undefined }));
                    }
                  }}
                  error={Boolean(customerErrors.companyName)}
                  helperText={customerErrors.companyName || ' '}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label={t("customer_name") + " *"}
                  value={newCustomerData.customerName || ''}
                  onChange={(e) => {
                    setNewCustomerData({ ...newCustomerData, customerName: e.target.value });
                    if (customerErrors.customerName) {
                      setCustomerErrors(prev => ({ ...prev, customerName: undefined }));
                    }
                  }}
                  error={Boolean(customerErrors.customerName)}
                  helperText={customerErrors.customerName || ' '}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label={t("email_address") + " *"}
                  type="email"
                  value={newCustomerData.email || ''}
                  onChange={(e) => {
                    setNewCustomerData({ ...newCustomerData, email: e.target.value });
                    if (customerErrors.email) {
                      setCustomerErrors(prev => ({ ...prev, email: undefined }));
                    }
                  }}
                  error={Boolean(customerErrors.email)}
                  helperText={customerErrors.email || ' '}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label={t("phone_number") + " *"}
                  value={newCustomerData.phoneNumber || ''}
                  onChange={(e) => {
                    setNewCustomerData({ ...newCustomerData, phoneNumber: e.target.value });
                    if (customerErrors.phoneNumber) {
                      setCustomerErrors(prev => ({ ...prev, phoneNumber: undefined }));
                    }
                  }}
                  error={Boolean(customerErrors.phoneNumber)}
                  helperText={customerErrors.phoneNumber || ' '}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label={t("peppol_id")}
                  value={newCustomerData.peppolId || ''}
                  onChange={(e) => setNewCustomerData({ ...newCustomerData, peppolId: e.target.value })}
                  placeholder="0208:1234567890"
                  helperText={t("peppol_id_hint") || "Optional"}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                />
              </Grid>
            </Grid>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box>
            <Typography variant="subtitle2" color="primary" fontWeight="600" sx={{ mb: 2 }}>
              {t("address_information")}
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t("street_address") + " *"}
                  value={newCustomerData.street || ''}
                  onChange={(e) => {
                    setNewCustomerData({ ...newCustomerData, street: e.target.value });
                    if (customerErrors.street) {
                      setCustomerErrors(prev => ({ ...prev, street: undefined }));
                    }
                  }}
                  error={Boolean(customerErrors.street)}
                  helperText={customerErrors.street || ' '}
                  multiline
                  rows={2}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label={t("box_unit")}
                  value={newCustomerData.box || ''}
                  onChange={(e) => setNewCustomerData({ ...newCustomerData, box: e.target.value })}
                  helperText=" "
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label={t("postal_code") + " *"}
                  value={newCustomerData.postCode || ''}
                  onChange={(e) => {
                    setNewCustomerData({ ...newCustomerData, postCode: e.target.value });
                    if (customerErrors.postCode) {
                      setCustomerErrors(prev => ({ ...prev, postCode: undefined }));
                    }
                  }}
                  error={Boolean(customerErrors.postCode)}
                  helperText={customerErrors.postCode || ' '}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label={t("city") + " *"}
                  value={newCustomerData.city || ''}
                  onChange={(e) => {
                    setNewCustomerData({ ...newCustomerData, city: e.target.value });
                    if (customerErrors.city) {
                      setCustomerErrors(prev => ({ ...prev, city: undefined }));
                    }
                  }}
                  error={Boolean(customerErrors.city)}
                  helperText={customerErrors.city || ' '}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}>
                  <InputLabel>{t("country")}</InputLabel>
                  <Select
                    value={newCustomerData.country || 'Belgium'}
                    label={t("country")}
                    onChange={(e) => setNewCustomerData({ ...newCustomerData, country: e.target.value })}
                  >
                    <MenuItem value="Belgium">Belgium</MenuItem>
                    <MenuItem value="Netherlands">Netherlands</MenuItem>
                    <MenuItem value="France">France</MenuItem>
                    <MenuItem value="Germany">Germany</MenuItem>
                    <MenuItem value="Luxembourg">Luxembourg</MenuItem>
                  </Select>
                  <FormHelperText> </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}>
                  <InputLabel>{t("status")}</InputLabel>
                  <Select
                    value={newCustomerData.isActive || 'true'}
                    label={t("status")}
                    onChange={(e) => setNewCustomerData({ ...newCustomerData, isActive: e.target.value })}
                  >
                    <MenuItem value="true">{t("active")}</MenuItem>
                    <MenuItem value="false">{t("inactive")}</MenuItem>
                  </Select>
                  <FormHelperText> </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
          <Button
            onClick={handleCloseCustomerDialog}
            variant="outlined"
            sx={{
              textTransform: 'none',
              px: 3,
              borderRadius: 2,
              fontWeight: 600,
            }}
          >
            {t("cancel")}
          </Button>
          <Button
            onClick={handleCreateCustomer}
            variant="contained"
            sx={{
              textTransform: 'none',
              px: 3,
              borderRadius: 2,
              fontWeight: 600,
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #5568d3 0%, #6a3f91 100%)',
              },
            }}
          >
            {t("create")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ✅ Add Product Dialog */}
      <AddProductDialog
        open={openProductDialog}
        onClose={() => setOpenProductDialog(false)}
        onProductCreated={(createdProduct) => {
          if (createdProduct && createdProduct.Id) {
            // Extract price from various possible field names
            const productPrice = createdProduct.Price || 
                                createdProduct.SalePrice || 
                                createdProduct.price || 
                                createdProduct.salePrice || 
                                0;
            
            // Format product for selection
            const productForSelection = {
              value: createdProduct.Id,
              label: `${createdProduct.Name} (€${productPrice})`,
              Id: createdProduct.Id,
              Name: createdProduct.Name,
              SKU: createdProduct.SKU,
              BarCode: createdProduct.Barcode,
              SalePrice: productPrice,
              Price: productPrice,
              CostPrice: createdProduct.CostPrice,
              StockQuantity: createdProduct.StockQuantity,
              Description: createdProduct.Description,
              ProductCategoryId: createdProduct.CategoryId || createdProduct.ProductCategoryId,
              SupplierId: createdProduct.SupplierId,
              ProductBrandId: createdProduct.ProductBrandId,
            };
            
            
            // Select the newly created product
            dispatch(setSelectedProduct(productForSelection));
            dispatch(setPrice(productPrice.toString()));
            toast.success(t("product_created_and_selected") || "Product created and selected! You can now add it to the invoice.");
          }
        }}
        suppliersFromStore={suppliersFromStore}
        brandsFromStore={brandsFromStore}
        categoriesFromStore={categoriesFromStore}
        onSupplierCreated={(supplier) => dispatch(addSupplierToStore(supplier))}
        onBrandCreated={(brand) => dispatch(addBrandToStore(brand))}
        onCategoryCreated={(category) => dispatch(addCategoryToStore(category))}
      />

      {/* ✅ Multiple Payment Method Creation Dialog */}
      <Dialog 
        open={showMultipleMethodDialog} 
        onClose={handleCancelMultipleMethod}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <PaymentIcon />
          {t('create_payment_method') || 'Create Payment Method'}
        </DialogTitle>
        <DialogContent sx={{ mt: 3 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {t('multiple_payment_method_message') || 'To use multiple payment methods, you need to create a "MULTIPLE" payment method first.'}
          </Typography>
          <TextField
            fullWidth
            label={t('payment_method_name') || 'Payment Method Name'}
            value="MULTIPLE"
            disabled
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
                fontWeight: 600,
              }
            }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button 
            onClick={handleCancelMultipleMethod}
            variant="outlined"
            disabled={creatingMultipleMethod}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            {t('cancel') || 'Cancel'}
          </Button>
          <Button 
            onClick={handleCreateMultiplePaymentMethod}
            variant="contained"
            disabled={creatingMultipleMethod}
            startIcon={creatingMultipleMethod ? <CircularProgress size={20} color="inherit" /> : <CheckCircle />}
            sx={{
              borderRadius: 2,
              fontWeight: 600,
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #5568d3 0%, #6a3f91 100%)',
              },
            }}
          >
            {creatingMultipleMethod ? (t('creating') || 'Creating...') : (t('confirm') || 'Confirm')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ✅ Full Page Loading Overlay */}
      {creatingInvoice && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            backdropFilter: 'blur(4px)',
          }}
        >
          <CircularProgress 
            size={60} 
            sx={{ 
              color: '#fff',
              mb: 3,
            }} 
          />
          <Typography 
            variant="h6" 
            sx={{ 
              color: '#fff',
              fontWeight: 600,
              textAlign: 'center',
              px: 2,
            }}
          >
            {isEditMode ? t("updating_invoice") : t("creating_invoice")}
          </Typography>
          <Typography 
            variant="body2" 
            sx={{ 
              color: 'rgba(255, 255, 255, 0.8)',
              mt: 1,
              textAlign: 'center',
              px: 2,
            }}
          >
            {t("please_wait")}
          </Typography>
        </Box>
      )}

      <UnsavedChangesDialog
        open={blocker.state === 'blocked'}
        onDiscard={() => blocker.proceed?.()}
        onCancel={() => blocker.reset?.()}
      />
    </Box>
  );
}

function generateInvoiceNumber(lastNumber = 1) {
  const year = new Date().getFullYear();
  return `INV-${year}-${String(lastNumber).padStart(4, "0")}`;
}

export default AddInvoicePage;
